<template>
  <div style="background:#FAFAFA;" class="policeLato">

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5 pt-5" v-if="isDesktop()">
      <div class="paralax-cover-image has-background-dim">
        <p class="paralax-cover-image-text">
        <div class="content_home" style="z-index: 1!important">
          <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{$t('devis.devis_sante.header_title[0]')}}</span></h1>
          <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{$t('devis.devis_sante.header_title[1]')}}</span></h1>
        </div>
        </p>
      </div>
    </section>

    <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
    <section class="mt-5" v-if="isMobile()">
      <div class="paralax-cover-image_mobile has-background-dim_mobile">
        <p class="paralax-cover-image-text_mobile">
        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
          <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{$t('devis.devis_sante.header_title[0]')}}</span></h1>
          <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{$t('devis.devis_sante.header_title[1]')}}</span></h1>
        </div>
        </p>
      </div>
    </section>

    <div>
      <div class="container" style="background:#FAFAFA">
        <div class="container justify-content-center row text-center mb-5 mt-5">
          <p class="mb-3" style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">{{$t('devis.devis_sante.assur_care.title[0]')}} <span class="font-weight-bold">{{$t('devis.devis_sante.assur_care.title[1]')}}</span> {{$t('devis.devis_sante.assur_care.title[2]')}} <span class="font-weight-bold">{{$t('devis.devis_sante.assur_care.title[3]')}}</span></p> <br>
        </div>
        <br>


        <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title">{{$t('devis.devis_sante.assur_care.stepper_title[0]')}}</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title">{{$t('devis.devis_sante.assur_care.stepper_title[1]')}}</div>
                  </li>
                  <li class="step" id="thirstStep">
                    <div class="step-title">{{$t('devis.devis_sante.assur_care.stepper_title[2]')}}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="background:#FAFAFA" v-if="isMobile()">
          <div class="col-md-10" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="wizard-navigation">
                <div class="wizard-progress-with-circle">
                  <div class="wizard-progress-bar" style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;"></div>
                </div>
                <div class="progress-bar-group">
                  <div class="progress-bar-custom" id="testup"></div>
                </div>
                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                  <li class="step" id="firstStep">
                    <div class="step-title text-center mr-4">{{$t('devis.devis_sante.assur_care.stepper_title[0]')}}</div>
                  </li>
                  <li class="step" id="secondStep">
                    <div class="step-title text-center mr-4">{{$t('devis.devis_sante.assur_care.stepper_title[1]')}}</div>
                  </li>
                  <li class="step" id="thirstStep">
                    <div class="step-title text-center mr-4">{{$t('devis.devis_sante.assur_care.stepper_title[2]')}}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.lg.xl class="mt-5 row" style="background:#FAFAFA">
          <div class="col-md-10 offset-1" style="background:#FAFAFA">
            <div class="form" style="background:#FAFAFA">
              <div class="page">
                <div class="wizard-tab-content">
                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                    <div>
                      <div class="fields">
                        <section class="section-sm-bottom-85">
                          <div class="container mt-1">
                            <div class="row gx-xxl-6">
                              <div class="col-12 col-lg-12" id="testResize" v-show="step === 1" >
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content">
                                                  <div role="tabpanel" id="Step1_choix" aria-labelledby="step-Step1_choix" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="field-title font-weight-bold">{{$t('devis.devis_sante.assur_care.titre_stepr_1')}}</div>
                                                        <div class="mt-3 field-group justify-content-center row flex-column flex-sm-row">
                                                          <div class="btn-choice btn-choice-icon sm-no-change">
                                                            <input v-model="packOffreSante" value="pack_essentiel" type="radio" id="pack_essentiel" name="Step1_1" class="field-input" @change="ShowDetailsPack">
                                                            <label id="card_width_basic" for="pack_essentiel" class="pack flex-row flex-md-column field-label" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .1)">
                                                              <h3>70%</h3>
                                                              <h4 >{{$t('devis.devis_sante.assur_care.pack_essentiel_content.pack_title')}}</h4>
                                                              <span class="link-text">
                                                               <!-- 150 000 FCFA -->
                                                               {{$t('devis.devis_sante.assur_care.pack_essentiel_content.prix')}}
                                                            </span>
                                                              <span style="position: absolute;bottom:7px!important;font-size:10px!important">10 pers. minimum</span>
                                                            </label>
                                                          </div>
                                                          <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                            <input v-model="packOffreSante" value="pack_serenite" type="radio" id="pack_serenite" name="Step1_1" class="field-input" @change="ShowDetailsPack">
                                                            <label id="card_width_essentiel" for="pack_serenite" class="pack flex-row flex-md-column field-label" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .1)">
                                                              <h3>80%</h3>
                                                              <h4>{{$t('devis.devis_sante.assur_care.pack_serenite_content.pack_title')}}</h4>
                                                              <span class="link-text">
                                                                <!-- 290 000 FCFA -->
                                                                {{$t('devis.devis_sante.assur_care.pack_serenite_content.prix')}}
                                                            </span>
                                                            </label>
                                                          </div>
                                                          <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                            <input v-model="packOffreSante" value="pack_confort" type="radio" id="pack_confort" name="Step1_1" class="field-input" @change="ShowDetailsPack">
                                                            <label id="card_width_confort" for="pack_confort" class="pack flex-row flex-md-column field-label" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .1)">
                                                              <h3>90%</h3>
                                                              <h4>{{$t('devis.devis_sante.assur_care.pack_confort_content.pack_title')}}</h4>
                                                              <span class="link-text">
                                                               <!-- 370 000 FCFA -->
                                                               {{$t('devis.devis_sante.assur_care.pack_confort_content.prix')}}
                                                            </span>
                                                            </label>
                                                          </div>
                                                         
                                                        </div>
                                                      </div> 
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-tab-content" v-show="packOffreSante === 'pack_essentiel'">
                                                  <div role="tabpanel" id="text_pack_full_2" aria-hidden="true" aria-labelledby="step-text_pack_full_2" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="field-title mb-0">
                                                          {{$t('devis.devis_sante.assur_care.inclus')}} : 
                                                        </div>
                                                        <div class="row">
                                                          <div class="ml-5 justify-content-center block">
                                                            <img src="../assets/img/assurcare/hopital.png" alt="hopital" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="text-center justify-center row">{{$t('devis.devis_sante.assur_care.poste_sante_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/pharmacie.png" alt="pharmacie" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.pharmacie_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/hospital.png" alt="hopital" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.hopital_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/labo.png" alt="labo" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.laboratoire_option_label')}}</p>
                                                          </div>
                                                        </div>
                                                        
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-tab-content" v-show="packOffreSante === 'pack_serenite'">
                                                  <div role="tabpanel" id="text_pack_full_2" aria-hidden="true" aria-labelledby="step-text_pack_full_2" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="field-title mb-0">
                                                          {{$t('devis.devis_sante.assur_care.inclus')}} : 
                                                        </div>
                                                        <div class="row">
                                                          <div class="ml-5 justify-content-center block">
                                                            <img src="../assets/img/assurcare/hopital.png" alt="hopital" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.poste_sante_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/hospital.png" alt="hopital" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.hopital_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/pharmacie.png" alt="pharmacie" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.pharmacie_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/ambulance.png" alt="ambulance" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.ambulance_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/labo.png" alt="labo" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row"> {{$t('devis.devis_sante.assur_care.laboratoire_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/dentaire.png" alt="dentaire" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.dentaire_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/optique.png" alt="optique" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.optique_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/maternite.png" alt="maternite" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.maternite_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/senior_card.png" alt="senior_card" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.age_senior_option_label')}}</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-tab-content" v-show="packOffreSante === 'pack_confort'">
                                                  <div role="tabpanel" id="text_pack_full_2" aria-hidden="true" aria-labelledby="step-text_pack_full_2" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="field-title mb-0">
                                                          {{$t('devis.devis_sante.assur_care.inclus')}} : 
                                                        </div>
                                                        <div class="row">
                                                          <div class="ml-5 justify-content-center block">
                                                            <img src="../assets/img/assurcare/hopital.png" alt="hopital" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.poste_sante_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/hospital.png" alt="hopital" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.hopital_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/pharmacie.png" alt="pharmacie" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.pharmacie_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/ambulance.png" alt="ambulance" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.ambulance_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/labo.png" alt="labo" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.laboratoire_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/dentaire.png" alt="dentaire" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.dentaire_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/optique.png" alt="optique" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.optique_option_label')}}</p>
                                                          </div>
                                                          <div class="justify-content-center block ml-5">
                                                            <img src="../assets/img/assurcare/maternite.png" alt="maternite" style="background-color: #fff;box-shadow: 0 0.5rem 0rem rgba(0,0,0,0.1);border-radius: 50%;width:50px;height:50px">
                                                            <p class="justify-center row">{{$t('devis.devis_sante.assur_care.maternite_option_label')}}</p>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-lg-8" v-show="step === 2" >
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content">
                                                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="field-title font-weight-bold">{{$t('devis.devis_sante.assur_care.titre_stepr_2')}}</div>
                                                        <v-layout class="justify-content-center column" style="width: auto">
                                                          <!--PARTIE HOMME-->
                                                          <div class="wizard-tab-content">
                                                            <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                                              <div>
                                                                <div class="fields">
                                                                  <div class="justify-center row field-title mb-4">
                                                                    {{$t('devis.devis_sante.assur_care.adulte_assure.nombre_adulte_label')}} 
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <v-flex class="justify-content-center row mt-3 mb-3">
                                                            <div>
                                                              <div class='main'>
                                                                <img src="../assets/img/assurcare/homme.png" alt="homme" width="60" style="height: 60px!important;margin-top: -20px!important;">
                                                                <button @click="decrementAdulteHomme()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                                                <input class='new_counter' :value="nbreAdulteHomme" readonly/>
                                                                <button @click="incrementAdulteHomme()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                                              </div>
                                                            </div>

                                                            <div class="ml-5">
                                                              <div class='main'>
                                                                <img src="../assets/img/assurcare/femme.png" alt="femme" width="50" style="height: 50px!important;margin-top: -20px!important;">
                                                                <button @click="decrementAdulteFemme()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                                                <input class='new_counter' type="text" placeholder="value..." :value="nbreAdulteFemme" readonly />
                                                                <button @click="incrementAdulteFemme()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                                              </div>
                                                            </div>
                                                          </v-flex>
                                                          <div class="wizard-tab-content">
                                                            <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                                              <div>
                                                                <div class="fields">
                                                                  <div class="justify-center field-title mb-0">
                                                                    {{$t('devis.devis_sante.assur_care.adulte_assure.total_adulte_label')}} : <span style="color:#ffa409;font-weight:600">{{ adulteTotal }}</span><br/>
                                                                    {{$t('devis.devis_sante.assur_care.prime_nette_label')}} : <span v-if="prixNetforAdulte != null" style="color:#ffa409;font-weight:600">{{ prixNetforAdulte.toLocaleString() }} FCFA</span> 
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <v-divider class="pt-3"></v-divider>

                                                          <!--PARTIE ENFANT-->
                                                          <div class="wizard-tab-content">
                                                            <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                                              <div>
                                                                <div class="fields">
                                                                  <div class="justify-center row field-title mb-4">
                                                                    {{$t('devis.devis_sante.assur_care.enfant_assure.nombre_enfant_label')}} 
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <v-flex class="justify-content-center row mt-3">
                                                            <div>
                                                              <div class='main'>
                                                                <img src="../assets/img/assurcare/garcon.png" alt="garcon" width="50" style="height: 50px!important;margin-top: -20px!important;">
                                                                <button @click="decrementEnfantGarcon()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                                                <input class='new_counter' :value="nbreEnfantGarcon" readonly/>
                                                                <button @click="incrementEnfantGarcon()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                                              </div>
                                                            </div>

                                                            <div class="ml-5">
                                                              <div class='main'>
                                                                <img src="../assets/img/assurcare/fille.png" alt="fille" width="50" style="height: 50px!important;margin-top: -20px!important;">
                                                                <button @click="decrementEnfantFille()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                                                <input class='new_counter' type="text" placeholder="value..." :value="nbreEnfantFille" readonly />
                                                                <button @click="incrementEnfantFille()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                                              </div>
                                                            </div>
                                                          </v-flex>

                                                          <div class="wizard-tab-content">
                                                            <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                                              <div>
                                                                <div class="fields">
                                                                  <div class="justify-center field-title mb-0">
                                                                    {{$t('devis.devis_sante.assur_care.enfant_assure.total_enfant_label')}} : <span style="color:#ffa409;font-weight:600">{{ enfantTotal }}</span><br/>
                                                                    {{$t('devis.devis_sante.assur_care.prime_nette_label')}} : <span v-if="prixNetforEnfant != null" style="color:#ffa409;font-weight:600">{{ prixNetforEnfant.toLocaleString() }} FCFA</span> 
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <v-divider v-if="isSenior" class="pt-3"></v-divider>

                                                          <!--PARTIE SENIOR-->
                                                          <div class="wizard-tab-content" v-if="isSenior">
                                                            <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                                              <div>
                                                                <div class="fields">
                                                                  <div class="justify-center row field-title mb-4">
                                                                    {{$t('devis.devis_sante.assur_care.senior_assure.nombre_senior_label')}} 
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <v-flex class="justify-content-center row mt-3" v-if="isSenior">
                                                            <div>
                                                              <div class='main'>
                                                                <img src="../assets/img/assurcare/oldman.png" alt="vieux" width="50" style="height: 50px!important;margin-top: -20px!important;">
                                                                <button @click="decrementSeniorHomme()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                                                <input class='new_counter' :value="nbreSeniorHomme" readonly/>
                                                                <button @click="incrementSeniorHomme()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                                              </div>
                                                            </div>

                                                            <div class="ml-5">
                                                              <div class='main'>
                                                                <img src="../assets/img/assurcare/oldmowen.png" alt="vielle" width="50" style="height: 50px!important;margin-top: -20px!important;">
                                                                <button @click="decrementSeniorFemme()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                                                <input class='new_counter' :value="nbreSeniorFemme" readonly />
                                                                <button @click="incrementSeniorFemme()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                                              </div>
                                                            </div>
                                                          </v-flex>
                                                          <div class="wizard-tab-content" v-if="isSenior">
                                                            <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                                              <div>
                                                                <div class="fields">
                                                                  <div class="justify-center field-title mb-0">
                                                                    {{$t('devis.devis_sante.assur_care.senior_assure.total_senior_label')}} : <span style="color:#ffa409;font-weight:600">{{ seniorTotal }}</span><br/>
                                                                    {{$t('devis.devis_sante.assur_care.prime_nette_label')}} : <span v-if="prixNetforSenior != null" style="color:#ffa409;font-weight:600">{{ prixNetforSenior.toLocaleString() }} FCFA</span> 
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </v-layout>
                                                      </div>
                                                      <v-divider class="pt-3" v-if="this.pack == 'serenite' || this.pack == 'confort'"></v-divider>
                                                      <div class="fields" v-if="this.pack == 'serenite' || this.pack == 'confort'">
                                                        <div class="row">
                                                          <div class="col-sm-12">
                                                            <div class="wizard-tab-content">
                                                                <div role="tabpanel" id="zone" aria-hidden="true" aria-labelledby="step-zone" class="wizard-tab-container">
                                                                  <div>
                                                                    <div class="fields">
                                                                      <div class="justify-center row field-title mb-4">
                                                                         {{$t('devis.devis_sante.assur_care.zone_couverture_label')}}
                                                                      </div>
                                                                    </div>

                                                                     <div class="fields">
                                                                      <div class="row">
                                                                        <div class="col-sm-6" v-for="item in zoneList" :key="item">
                                                                          <div class="mt-2 btn-choice">
                                                                              <input @change="calculPrimeZone()" v-model="zone" type="radio" :value="item.value" :id="item.name" name="zone" class="field-input">
                                                                              <label :for="item.name" class="field-label btn-choice-hide-dot" style="padding: 8px!important">
                                                                                <span>{{item.name}}</span>
                                                                                <div class="wizard-tab-content" style="margin-top: -20px!important;">
                                                                                  <div role="tabpanel" id="choix_zone" aria-hidden="true" aria-labelledby="step-choix_zone" class="wizard-tab-container">
                                                                                    <div>
                                                                                      <div class="fields">
                                                                                        <div class="justify-center field-title mb-0">
                                                                                          <span style="color:#ffa409;font-weight:600">{{ item.prix.toLocaleString() }} FCFA</span> 
                                                                                        </div>
                                                                                      </div>
                                                                                    </div>
                                                                                  </div>
                                                                                </div>
                                                                              </label>
                                                                            </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                          </div>
                                                        </div>
                                                      </div>

                                                     
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix mb-3">
                                                  <div class="wizard-footer-left">
                                                    <button @click="BacktoFirstStep()" type="button" class="wizard-btn">
                                                      <span class="fas fa-arrow-left"></span>
                                                      {{$t('devis.devis_sante.assur_care.bouton_retour_label')}}
                                                    </button>
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="nextStepToOption()" type="button" class="wizard-btn">
                                                      {{$t('devis.devis_sante.assur_care.bouton_suivant_label')}}
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-lg-8" v-show="step === 3">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content">
                                                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                    <div>
                                                      <div class="fields">
                                                        <div class="fields">
                                                          <div class="field-title font-weight-bold">{{$t('devis.devis_sante.assur_care.titre_stepr_4')}}</div>
                                                          <div class="mt-3 justify-content-center row">
                                                            <div class="souscrip_switch">
                                                              <input v-model="ContractantFields.Genre" value="homme" type="radio" id="monsieur_desktop" name="genre_situa_desktop" /><label for="monsieur_desktop">{{$t('devis.devis_sante.assur_care.souscripteur_form.monsieur_label')}}</label>
                                                              <input v-model="ContractantFields.Genre" value="femme" type="radio" id="madame_desktop" name="genre_situa_desktop" /><label for="madame_desktop">{{$t('devis.devis_sante.assur_care.souscripteur_form.madame_label')}}</label>
                                                            </div>
                                                            <div class="souscrip_switch ml-5">
                                                              <input v-model="ContractantFields.Situation" value="marié" type="radio" id="marié_desktop" name="matri_situa_desktop" /><label for="marié_desktop">{{$t('devis.devis_sante.assur_care.souscripteur_form.marie_label')}}</label>
                                                              <input v-model="ContractantFields.Situation" value="célibataire" type="radio" id="celi_desktop" name="matri_situa_desktop" /><label for="celi_desktop">{{$t('devis.devis_sante.assur_care.souscripteur_form.celibat_label')}}</label>
                                                            </div>
                                                          </div>
                                                          <div class="mt-4 row">
                                                            <div class="col-sm-4">
                                                              <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.nom_label')}}</label>
                                                                <input v-model="ContractantFields.Nom" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.nom_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                              </div>
                                                            </div>
                                                            <div class="col-sm-4">
                                                              <div class="field-group field-default">
                                                                <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.prenom_label')}}</label>
                                                                <input v-model="ContractantFields.Prenom" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.prenom_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                              </div>
                                                            </div>
                                                            <div class="col-sm-4">
                                                              <div class="field-group field-default" style="margin-top:-2px">
                                                                <label for="Stepper25" class="field-label">
                                                                  {{$t('devis.devis_sante.assur_care.souscripteur_form.date_naissance_label')}}
                                                                  <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                  <date-picker class="field-input ml-2 mb-1 mt-1" :disabled-date="disabledAfterToday" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.date_naissance_placeholder')" id="Stepper25" @change="yearsDiffContractant()" v-model="ContractantFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="mt-4 row">
                                                            <div class="col-sm-4">
                                                              <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.lieu_naissance_label')}}</label>
                                                                <input v-model="ContractantFields.LieuNaissance" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.lieu_naissance_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                              </div>
                                                            </div>
                                                            <div class="col-sm-4">
                                                              <div class="field-group field-default">
                                                                <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.telephone_label')}}</label>
                                                                <input @keypress="onlyNumber" v-model="ContractantFields.Telephone" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.telephone_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                <div id="error">{{ errors.phone }}</div>
                                                              </div>
                                                            </div>
                                                            <div class="col-sm-4">
                                                              <div class="field-group field-default" style="margin-top:-2px">
                                                                <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.email_label')}}</label>
                                                                <input v-model="ContractantFields.Email" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.email_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                                                <div id="error">{{ errors.email }}</div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div class="wizard-card-footer clearfix mb-3">
                                                  <div class="wizard-footer-left">
                                                    <button @click="BacktoSecondStep()" type="button" class="wizard-btn">
                                                      <span class="fas fa-arrow-left"></span>
                                                      {{$t('devis.devis_sante.assur_care.bouton_retour_label')}}
                                                    </button>
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button @click="ContractControl()" type="button" class="wizard-btn">
                                                      {{$t('devis.devis_sante.assur_care.bouton_suivant_label')}}
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12 col-lg-8" v-show="step === 4">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="post">
                                      <div class="post-body">
                                        <div>
                                          <div class="articleContent s-post page-h2 page-h3" style="margin-top:60px;border-radius: 15px!important;box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                            <div class="form">
                                              <div class="page">
                                                <div class="wizard-tab-content">
                                                  <div role="tabpanel" id="Step1" aria-labelledby="step-Step1" class="wizard-tab-container">
                                                    <div class="field-title font-weight-bold">{{$t('devis.devis_sante.assur_care.titre_stepr_5')}}</div>
                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.title')}}</p>
                                                      </div>
                                                    </div>
                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                      <div class="col-sm-12">
                                                        <div class="field-group field-default">
                                                          <ul class="to-left mb-3 mr-3 policeLato">
                                                            <li class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.genre_label')}} :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Genre}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.situation_label')}} :
                                                              <span class="font-weight-bold  to-right">{{ContractantFields.Situation}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.nom_label')}} :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Nom}}</span>
                                                            </li>


                                                            <li class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.prenom_label')}} :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Prenom}}</span>
                                                            </li>

                                                            <li  class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.date_naissance_label')}} :
                                                              <span class="font-weight-bold to-right">{{DateFormater(ContractantFields.dateNaissance)}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.lieu_naissance_label')}} :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.LieuNaissance}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.telephone_label')}} :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Telephone}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.email_label')}} :
                                                              <span class="font-weight-bold to-right">{{ContractantFields.Email}}</span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.title')}}</p>
                                                      </div>
                                                    </div>

                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                      <div class="col-sm-12">
                                                        <div class="field-group field-default">
                                                          <ul class="to-left mb-3 mr-3 policeLato">
                                                            <p class="font-weight-bold" style="font-size: 20px" v-if="this.adulteTotal > 0">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.adulte_label')}}</p>
                                                            <li class="subheading" v-if="this.nbreAdulteHomme > 0" style="margin-top:-30px;list-style: none;">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.homme_label')}} :
                                                              <span class="font-weight-bold to-right">{{nbreAdulteHomme}}</span>
                                                            </li>

                                                            <li class="subheading" v-if="this.nbreAdulteFemme > 0" style="list-style: none;">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.femme_label')}} :
                                                              <span class="font-weight-bold to-right">{{nbreAdulteFemme}}</span>
                                                            </li>

                                                            <p class="mt-5 font-weight-bold" style="font-size: 20px" v-if="this.enfantTotal > 0">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.enfant_label')}}</p>

                                                            <li class="subheading" v-if="this.nbreEnfantGarcon > 0" style="margin-top:-30px;list-style: none;">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.garcon_label')}} :
                                                              <span class="font-weight-bold to-right">{{nbreEnfantGarcon}}</span>
                                                            </li>

                                                            <li class="subheading" style="list-style: none" v-if="this.nbreEnfantFille > 0" >{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.fille_label')}} :
                                                              <span class="font-weight-bold to-right">{{nbreEnfantFille}}</span>
                                                            </li>

                                                            <p v-if="isSenior" class="mt-5 font-weight-bold" style="font-size: 20px">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.senior_label')}}</p>
                                                            <li v-if="isSenior" class="subheading" style="margin-top:-30px;list-style: none;">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.homme_senior_label')}} :
                                                              <span class="font-weight-bold to-right">{{nbreSeniorHomme}}</span>
                                                            </li>

                                                            <li v-if="isSenior" class="subheading" style="list-style: none;">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.femme_senior_label')}} :
                                                              <span class="font-weight-bold to-right">{{nbreSeniorFemme}}</span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.detail_assurance_step.garantie.title')}}</p>
                                                      </div>
                                                    </div>

                                                    <div class="row" style="margin-top: -20px !important;background: #fafafa;border-radius: 12px;box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);">
                                                      <div class="col-sm-12">
                                                        <div class="field-group field-default">
                                                          <ul class="to-left mb-3 mr-3 policeLato">
                                                            <p class="font-weight-bold" style="font-size: 20px">{{$t('devis.devis_sante.assur_care.detail_assurance_step.garantie.pack_choice_label')}}</p>
                                                            <li class="subheading" style="margin-top:-30px;list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.garantie.nom_pack_label')}} :
                                                              <!--<span class="to-right">{{pack}}</span>-->
                                                              <span class="font-weight-bold to-right" v-if="this.pack == 'essentiel'">{{packBasic.nomPack}}</span>
                                                              <span class="font-weight-bold to-right" v-if="this.pack == 'serenite'">{{packEssentiel.nomPack}}</span>
                                                              <span class="font-weight-bold to-right" v-if="this.pack == 'confort'">{{packConfort.nomPack}}</span>
                                                            </li>


                                                            <li class="subheading" style="list-style: none">{{$t('devis.devis_sante.assur_care.detail_assurance_step.garantie.prix_base_label')}} :
                                                              <span class="font-weight-bold to-right" v-if="this.pack == 'essentiel'">{{packBasic.prix.toLocaleString()}} FCFA</span>
                                                              <span class="font-weight-bold to-right" v-if="this.pack == 'serenite'">{{packEssentiel.prix.toLocaleString()}} FCFA</span>
                                                              <span class="font-weight-bold to-right" v-if="this.pack == 'confort'">{{packConfort.prix.toLocaleString()}} FCFA</span>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{ $t('devis.devis_auto.choix_assureurs') }}</p>
                                                      </div>
                                                    </div>

                                                    <div class="fields">
                                                       <!-- Grid moderne pour les assureurs -->
                                                                              <div class="insurers-grid">
                                                                                <!-- Bouton "Tous" -->
                                                                                <div class="insurer-card all-insurers" :class="{ 'selected': selectAll }">
                                                                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="insurer-input">
                                                                                  <label for="tous_mobile" class="insurer-label">
                                                                                    <div class="insurer-icon">
                                                                                      <img src="../assets/img/icones/all.png" alt="Tous les assureurs" class="insurer-logo">
                                                                                    </div>
                                                                                    <div class="insurer-info">
                                                                                      <h4 class="insurer-name">{{ $t('devis.devis_auto.bouton_tous') }}</h4>
                                                                                      <span class="insurer-badge">Tous</span>
                                                                                    </div>
                                                                                    <div class="selection-indicator">
                                                                                      <i class="fas fa-check"></i>
                                                                                    </div>
                                                                                  </label>
                                                                                </div>
                                                
                                                                                <!-- Cartes des assureurs -->
                                                                                <div 
                                                                                  class="insurer-card" 
                                                                                  v-for="assure in listeAssureurs" 
                                                                                  :key="assure._id"
                                                                                  :class="{ 'selected': assureurs.includes(assure.societe) }"
                                                                                >
                                                                                  <input 
                                                                                    v-model="assureurs" 
                                                                                    type="checkbox" 
                                                                                    :value="assure.societe" 
                                                                                    :id="assure.societe"
                                                                                    class="insurer-input"
                                                                                  >
                                                                                  <label :for="assure.societe" class="insurer-label">
                                                                                    <div class="insurer-icon">
                                                                                      <img :src="assure.logo" :alt="assure.societe" class="insurer-logo">
                                                                                    </div>
                                                                                    <div class="insurer-info">
                                                                                      <h4 class="insurer-name">{{ assure.societe }}</h4>
                                                                                      <span class="insurer-badge">Assureur</span>
                                                                                    </div>
                                                                                    <div class="selection-indicator">
                                                                                      <i class="fas fa-check"></i>
                                                                                    </div>
                                                                                  </label>
                                                                                </div>
                                                                              </div>
                                                
                                                                              <!-- Résumé de la sélection -->
                                                                              <div class="selection-summary" v-if="assureurs.length > 0">
                                                                                <div class="summary-content">
                                                                                  <i class="fas fa-info-circle"></i>
                                                                                  <span>{{ assureurs.length }} {{ $t('devis.devis_auto.assureur_label') }}{{ assureurs.length > 1 ? 's' : '' }} {{ $t('devis.devis_auto.selectionne_label') }}{{ assureurs.length > 1 ? 's' : '' }}</span>
                                                                                </div>
                                                                              </div>



                                                      <!-- <div class="field-group row field-bank">
                                                        <div class="btn-choice col-sm-6 col-6" v-for="assure in listeAssureurs" :key="assure._id">
                                                      <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe"
                                                        class="field-input">
                                                      <label :for="assure.societe" class="field-label" :label="assure.societe">
                                                        <img :src="assure.logo" :alt="assure.societe" height="50">
                                                        <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">{{ assure.societe }}</p>
                                                      </label>
                                                    </div>
                                                      </div> -->
                                                        </div>

                                                  

                                                    <div class="mt-3 justify-content-center row">
                                                      <div class="justify-content-center row">
                                                        <p class="font-weight-bold field-title" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.detail_assurance_step.periode.title')}}</p>
                                                      </div>
                                                    </div>

                                                    <div class="row">
                                                      <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                          <label for="Stepper39" class="field-label">{{$t('devis.devis_sante.assur_care.detail_assurance_step.periode.date_effet')}}
                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                          <div class="input-group rate-loan">
                                                            <date-picker id="Stepper39" :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_sante.assur_care.detail_assurance_step.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div class="col-sm-6">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                          <label for="Stepper40" class="field-label">{{$t('devis.devis_sante.assur_care.detail_assurance_step.periode.date_echeance')}}
                                                            <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                                          <div class="input-group rate-loan">
                                                            <input disabled :placeholder="$t('devis.devis_sante.assur_care.detail_assurance_step.periode.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40" name="Step11" class="field-input">
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="wizard-card-footer clearfix mb-3">
                                                  <div class="wizard-footer-left">
                                                    <button @click="BacktoThirstStep()" type="button" class="wizard-btn">
                                                      <span class="fas fa-arrow-left"></span>
                                                      {{$t('devis.devis_sante.assur_care.bouton_retour_label')}}
                                                    </button>
                                                  </div>
                                                  <div class="wizard-footer-right">
                                                    <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                                                      {{$t('devis.devis_sante.assur_care.bouton_suivant_label')}}
                                                    </button>
                                                  </div>
                                                  <!---->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <aside class="col-12 col-lg-4" v-show="this.step === 1 || this.step === 2">
                                <div id="sidebar" class="c-sidebar" data-toggle="affix" v-show="packOffreSante === 'pack_essentiel'">
                                  <div class="c-cta-block" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                        <div>
                                          <div class="fields">
                                            <div class="justify-center field-title mb-0 text-center text-white">
                                              {{$t('devis.devis_sante.assur_care.pack_essentiel_content.pack_title')}} - <span class="mb-0" style="color:#ffa409;font-weight:600">{{$t('devis.devis_sante.assur_care.pack_essentiel_content.pourcent')}}</span><br/>
                                              {{$t('devis.devis_sante.assur_care.pack_essentiel_content.prix')}} / pers. <br/>
                                              <span class="mb-0" style="font-size:12px">10 pers. minimum</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="c-cta-block__title field-title">{{$t('devis.devis_sante.assur_care.pack_essentiel_content.avantages')}}</div>
                                    <p class="ml-1 mr-2 c-cta-block__content field-label justify-content-center row">
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[0]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[1]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[2]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[3]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[4]')}}
                                    </p>
                                    <div class="c-cta-block__title">{{$t('devis.devis_sante.assur_care.pack_essentiel_content.condition_particulier')}}</div>
                                    <p class="ml-1 mr-2 c-cta-block__content mt-3 justify-content-center row">
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_condition[0]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_condition[1]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_condition[2]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_condition[3]')}}
                                    </p>
                                    <div class="text-center" v-show="this.step === 1">
                                      <button type="button" class="c-btn-pink" @click="choix()">{{$t('devis.devis_sante.assur_care.choice_bouton_label')}}</button>
                                    </div>
                                  </div>
                                </div>
                                <div id="sidebar" class="c-sidebar" data-toggle="affix" v-show="this.packOffreSante === 'pack_serenite'">
                                  <div class="c-cta-block" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                        <div>
                                          <div class="fields">
                                            <div class="justify-center field-title mb-0 text-center text-white">
                                              {{$t('devis.devis_sante.assur_care.pack_serenite_content.pack_title')}} - <span class="mb-0" style="color:#ffa409;font-weight:600">{{$t('devis.devis_sante.assur_care.pack_serenite_content.pourcent')}}</span><br/>
                                              {{$t('devis.devis_sante.assur_care.pack_serenite_content.prix')}} / pers
                                            </div> 
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="c-cta-block__title field-title">{{$t('devis.devis_sante.assur_care.pack_serenite_content.avantages')}}</div>
                                    <p class="ml-1 mr-2 c-cta-block__content justify-content-center row">
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[0]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[1]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[2]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[3]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[4]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[5]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[6]')}}
                                    </p>
                                    <div class="c-cta-block__title">{{$t('devis.devis_sante.assur_care.pack_serenite_content.condition_particulier')}}</div>

                                    <p class="ml-1 mr-2 c-cta-block__content justify-content-center row mt-3">
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[0]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[1]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[2]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[3]')}} <br>
                                      <span class="font-weight-bold">{{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[4]')}}</span>
                                    </p>
                                    <div class="text-center" v-show="this.step === 1">
                                      <button type="mt-3 button" class="c-btn-pink" @click="choix2()">{{$t('devis.devis_sante.assur_care.choice_bouton_label')}}</button>
                                    </div>
                                  </div>
                                </div>
                                <div id="sidebar" class="c-sidebar" data-toggle="affix" v-show="this.packOffreSante === 'pack_confort'">
                                  <div class="c-cta-block" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                        <div>
                                          <div class="fields">
                                            <div class="justify-center field-title mb-0 text-center text-white">
                                              {{$t('devis.devis_sante.assur_care.pack_confort_content.pack_title')}} - <span class="mb-0" style="color:#ffa409;font-weight:600">{{$t('devis.devis_sante.assur_care.pack_confort_content.pourcent')}}</span><br/>
                                              {{$t('devis.devis_sante.assur_care.pack_confort_content.prix')}} / adulte
                                            </div> 
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="c-cta-block__title field-title">{{$t('devis.devis_sante.assur_care.pack_confort_content.avantages')}}</div>
                                    <p class="ml-1 mr-2 c-cta-block__content justify-content-center row">
                                      {{$t('devis.devis_sante.assur_care.pack_confort_content.content_avantage[0]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_confort_content.content_avantage[1]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_confort_content.content_avantage[2]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_confort_content.content_avantage[3]')}}
                                    </p>
                                    <div class="c-cta-block__title">{{$t('devis.devis_sante.assur_care.pack_confort_content.condition_particulier')}}</div>
                                    <p class="ml-1 mr-2 c-cta-block__content justify-content-center row mt-3">
                                      {{$t('devis.devis_sante.assur_care.pack_confort_content.content_condition[0]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_confort_content.content_condition[1]')}}<br>
                                      {{$t('devis.devis_sante.assur_care.pack_confort_content.content_condition[2]')}}
                                      <span class="font-weight-bold">{{$t('devis.devis_sante.assur_care.pack_confort_content.content_condition[3]')}}</span>
                                    </p>
                                    <div class="text-center" v-show="this.step === 1">
                                      <button type="mt-3 button" class="c-btn-pink" @click="choix3()">{{$t('devis.devis_sante.assur_care.choice_bouton_label')}}</button>
                                    </div>
                                  </div>
                                </div>
                              </aside>

                              <aside class="col-12 col-lg-4" v-show="step === 3 || step === 4">
                                <div id="sidebar" class="c-sidebar" data-toggle="affix">
                                  <div class="c-cta-block" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .2)">
                                    <div class="wizard-tab-content">
                                      <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                        <div>
                                          <div class="fields">
                                            <div class="justify-center field-title mb-0 text-white">
                                              {{$t('devis.devis_sante.assur_care.nombre_assure_label')}} <br/>
                                              <span class="mb-0" style="color:#ffa409;font-weight:600">{{ AllAssure }} personne(s)</span> 
                                            </div>

                                            <v-divider color="#fff"></v-divider>

                                             <div class="justify-center field-title mb-0 text-white" v-if="totalHorsTaxe !== null && this.totalHorsTaxe == 0">
                                              {{$t('devis.devis_sante.assur_care.prime_nette_label')}}<br/>
                                              <span class="mb-0" style="color:#ffa409;font-weight:600">{{prixNetTotal.toLocaleString()}} FCFA</span> 
                                            </div>

                                             <v-divider color="#fff"></v-divider>

                                             <div class="justify-center field-title mb-0 text-white" v-if="frais !== null">
                                              {{$t('devis.devis_sante.assur_care.accessoire_label')}}<br/>
                                              <span class="mb-0" style="color:#ffa409;font-weight:600">{{frais.toLocaleString()}} FCFA</span> 
                                            </div>

                                             <v-divider color="#fff"></v-divider>

                                             <div class="justify-center field-title mb-0 text-white" v-if="taxe !== null">
                                              {{$t('devis.devis_sante.assur_care.taxe_label')}}<br/>
                                              <span class="mb-0" style="color:#ffa409;font-weight:600">{{taxe.toLocaleString()}} FCFA</span> 
                                            </div>

                                            <v-divider color="#fff"></v-divider>

                                            <div class="justify-center field-title mb-0 text-white" v-if="zone !== null">
                                             Zone<br/>
                                            <span class="mb-0" style="color:#ffa409;font-weight:600">{{zone}}</span> 
                                            </div>

                                            <v-divider color="#fff"></v-divider>

                                            <div class="justify-center field-title mb-0 text-white" v-if="ttc !== null">
                                              {{$t('devis.devis_sante.assur_care.prime_total_label')}}<br/>
                                            <span class="mb-0" style="color:#5B94BC;font-weight:600">{{ttc.toLocaleString()}} FCFA</span> 
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </aside>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div v-responsive.sm.xs>
          <div class="mt-5" style="background:#FAFAFA">
            <div class="row" style="background:#FAFAFA">
              <div class="col-md-10" style="background:#FAFAFA">
                <div class="form" style="background:#FAFAFA">
                  <div class="page" v-show="step === 1">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile" class="wizard-tab-container">
                        <div>
                          <div class="fields">
                            <div data-v-0d43d413="" class="field-subtitle mb-3 justify-content-center" style="font-size:20px!important">
                              {{$t('devis.devis_sante.assur_care.titre_stepr_1')}}
                            </div>
                            <div class="field-group justify-content-center row flex-column flex-sm-row">
                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input v-model="packOffreSante" value="pack_essentiel" type="radio" id="pack_essentiel_mobile" name="Step1" class="field-input" @change="ShowDetailsPack">
                                <label id="card_width_basic" for="pack_essentiel_mobile" class="pack-mobile flex-row flex-md-column field-label" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .1)">
                                  <h3>70%</h3>
                                  <h4 >{{$t('devis.devis_sante.assur_care.pack_essentiel_content.pack_title')}}</h4>
                                  <span class="link-text">
                                    <!-- 150 000 FCFA/pers -->
                                    {{$t('devis.devis_sante.assur_care.pack_essentiel_content.prix')}}/pers.
                                </span>
                                  <span>10 pers. minimum</span>
                                </label>
                              </div>
                              <div class="wizard-tab-content" v-show="packOffreSante === 'pack_essentiel'">
                                <div role="tabpanel" id="text_pack_essentiel_mobile" aria-hidden="true" aria-labelledby="step-text_pack_essentiel_mobile" class="wizard-tab-container">
                                  <div>
                                    <div class="fields mt-3">
                                      <p class="field-sub-title">Voir les :
                                        <br>
                                        <span class="font-weight-bold" style="color:#ffa409" @click="detailsPopup = true">Avantages & Conditions</span>
                                      </p>
                                        <div class="wizard-footer-right mb-5">
                                          <button @click="choix()" type="button" class="wizard-btn">
                                            {{$t('devis.devis_sante.assur_care.choice_bouton_label')}}
                                          </button>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input v-model="packOffreSante" value="pack_serenite" type="radio" id="pack_serenite_mobile" name="Step1" class="field-input" @change="ShowDetailsPack">
                                <label id="card_width_essentiel" for="pack_serenite_mobile" class="pack-mobile flex-row flex-md-column field-label" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .1)">
                                  <h3>80%</h3>
                                  <h4>{{$t('devis.devis_sante.assur_care.pack_serenite_content.pack_title')}}</h4>
                                  <span class="link-text">
                                    {{$t('devis.devis_sante.assur_care.pack_serenite_content.prix')}}/pers.
                                </span>
                                </label>
                              </div>
                              <div class="wizard-tab-content" v-show="packOffreSante === 'pack_serenite'">
                                <div role="tabpanel" id="text_pack_serenite_mobile" aria-hidden="true" aria-labelledby="step-text_pack_serenite_mobile" class="wizard-tab-container">
                                  <div>
                                    <div class="fields mt-3">
                                      <p class="field-sub-title">Voir les :
                                        <br>
                                        <span class="font-weight-bold" style="color:#ffa409" @click="detailsPopup = true">Avantages & Conditions</span>
                                      </p>
                                      <div class="wizard-footer-right mb-5">
                                        <button @click="choix2()" type="button" class="wizard-btn">
                                          {{$t('devis.devis_sante.assur_care.choice_bouton_label')}}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="btn-choice btn-choice-icon sm-no-change">
                                <input v-model="packOffreSante" value="pack_confort" type="radio" id="pack_confort_mobile" name="Step1" class="field-input" @change="ShowDetailsPack">
                                <label id="card_width_confort" for="pack_confort_mobile" class="pack-mobile flex-row flex-md-column field-label" style="box-shadow: 9px 12px 18px rgba(0, 0, 0, .1)">
                                  <h3>90%</h3>
                                  <h4>{{$t('devis.devis_sante.assur_care.pack_confort_content.pack_title')}}</h4>
                                  <span class="link-text">
                                    {{$t('devis.devis_sante.assur_care.pack_confort_content.prix')}}/adulte.
                                </span>
                                </label>
                              </div>
                              <div class="wizard-tab-content" v-show="packOffreSante === 'pack_confort'">
                                <div role="tabpanel" id="text_pack_confort_mobile" aria-hidden="true" aria-labelledby="step-text_pack_confort_mobile" class="wizard-tab-container">
                                  <div>
                                    <div class="fields mt-3">
                                      <p class="field-sub-title">Voir les :
                                        <br>
                                        <span class="font-weight-bold" style="color:#ffa409" @click="detailsPopup = true">Avantages & Conditions</span>
                                      </p>
                                      <div class="wizard-footer-right">
                                        <button @click="choix3()" type="button" class="wizard-btn">
                                          {{$t('devis.devis_sante.assur_care.choice_bouton_label')}}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="page" v-show="step === 2">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step2_mobile" aria-hidden="true" aria-labelledby="step-Step2_mobile" class="wizard-tab-container">
                        <div>
                          <div class="fields">
                            <!-- PARTIE HOMME -->
                            <div class="wizard-tab-content">
                              <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                <div>
                                  <div class="fields">
                                    <div class="justify-center field-subtitle mb-0" style="font-size:20px!important">
                                      {{$t('devis.devis_sante.assur_care.adulte_assure.nombre_adulte_label')}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="mt-5 field-group row flex-column flex-sm-row">
                              <div class="justify-content-center row">
                                <div>
                                  <img src="../assets/img/assurcare/homme.png" alt="homme" width="60" style="margin-top: -20px!important;">
                                </div>

                                <div class="ml-5">
                                  <div class='main'>
                                    <button @click="decrementAdulteHomme()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                    <input class='new_counter' :value="nbreAdulteHomme" readonly/>
                                    <button @click="incrementAdulteHomme()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-5 justify-content-center row">
                                <div>
                                  <img src="../assets/img/assurcare/femme.png" alt="femme" width="60" style="margin-top: -20px!important;">
                                </div>

                                <div class="ml-5">
                                  <div class='main'>
                                    <button @click="decrementAdulteFemme()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                    <input class='new_counter' :value="nbreAdulteFemme" readonly/>
                                    <button @click="incrementAdulteFemme()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                  </div>
                                </div>
                               
                              </div>
                              <div class="wizard-tab-content">
                                  <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                    <div>
                                      <div class="fields">
                                        <div class="justify-center field-subtitle mb-0" style="font-size:20px!important">
                                          {{$t('devis.devis_sante.assur_care.adulte_assure.total_adulte_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ adulteTotal }}</span><br/>
                                          {{$t('devis.devis_sante.assur_care.prime_nette_label')}} : <span v-if="prixNetforAdulte != null" style="float:right;color:#ffa409;font-weight:600">{{ prixNetforAdulte.toLocaleString() }} FCFA</span> 
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              <v-divider></v-divider>
                            </div>
                          </div>
                          <div class="fields">
                            <div class="wizard-tab-content">
                                  <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                    <div>
                                      <div class="fields">
                                        <div class="justify-center field-subtitle mb-0" style="font-size:20px!important">
                                          {{$t('devis.devis_sante.assur_care.enfant_assure.nombre_enfant_label')}} 
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            <div class="mt-5 field-group row flex-column flex-sm-row">
                              <div class="justify-content-center row">
                                <div>
                                  <img src="../assets/img/assurcare/garcon.png" alt="garcon" width="60" style="margin-top: -20px!important;">
                                </div>

                                <div class="ml-5">
                                  <div class='main'>
                                    <button @click="decrementEnfantGarcon()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                    <input class='new_counter' :value="nbreEnfantGarcon" readonly/>
                                    <button @click="incrementEnfantGarcon()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-5 justify-content-center row">
                                <div>
                                  <img src="../assets/img/assurcare/fille.png" alt="fille" width="60" style="margin-top: -20px!important;">
                                </div>

                                <div class="ml-5">
                                  <div class='main'>
                                    <button @click="decrementEnfantFille()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                    <input class='new_counter' :value="nbreEnfantFille" readonly/>
                                    <button @click="incrementEnfantFille()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                  </div>
                                </div>
                              </div>
                              <div class="wizard-tab-content">
                                  <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                    <div>
                                      <div class="fields">
                                        <div class="justify-center field-subtitle mb-0" style="font-size:20px!important">
                                          {{$t('devis.devis_sante.assur_care.enfant_assure.total_enfant_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ enfantTotal }}</span><br/>
                                          {{$t('devis.devis_sante.assur_care.prime_nette_label')}} : <span v-if="prixNetforEnfant != null" style="float:right;color:#ffa409;font-weight:600">{{ prixNetforEnfant.toLocaleString() }} FCFA</span> 
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              <v-divider v-if="isSenior"></v-divider>
                            </div>
                          </div>
                          <div class="fields" v-if="isSenior">
                            <div class="wizard-tab-content">
                                  <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                    <div>
                                      <div class="fields">
                                        <div class="justify-center field-subtitle mb-0" style="font-size:20px!important">
                                          {{$t('devis.devis_sante.assur_care.senior_assure.nombre_senior_label')}}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            <div class="mt-5 field-group row flex-column flex-sm-row" v-if="isSenior">
                              <div class="justify-content-center row">
                                <div>
                                  <img src="../assets/img/assurcare/oldman.png" alt="vieux" width="60" style="margin-top: -20px!important;">
                                </div>

                                <div class="ml-5">
                                  <div class='main'>
                                    <button @click="decrementSeniorHomme()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                    <input class='new_counter' :value="nbreSeniorHomme" readonly/>
                                    <button @click="incrementSeniorHomme()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-5 justify-content-center row">
                                <div>
                                  <img src="../assets/img/assurcare/oldmowen.png" alt="vielle" width="60" style="margin-top: -20px!important;">
                                </div>

                                <div class="ml-5">
                                  <div class='main'>
                                    <button @click="decrementSeniorFemme()" class='down_count btn btn-secondary' title='Moins'>-</button>
                                    <input class='new_counter' :value="nbreSeniorFemme" readonly/>
                                    <button @click="incrementSeniorFemme()" class='up_count btn btn-secondary' title='Plus'>+</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="wizard-tab-content" v-if="isSenior">
                            <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                              <div>
                                <div class="fields">
                                  <div class="justify-center field-subtitle mb-0" style="font-size:20px!important">
                                    {{$t('devis.devis_sante.assur_care.senior_assure.total_senior_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ seniorTotal }}</span><br/>
                                    {{$t('devis.devis_sante.assur_care.prime_nette_label')}} : <span v-if="prixNetforSenior != null" style="float:right;color:#ffa409;font-weight:600">{{ prixNetforSenior.toLocaleString() }} FCFA</span> 
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <v-divider class="pt-3" v-if="this.pack == 'serenite' || this.pack == 'confort'"></v-divider>
                            <div class="fields" v-if="this.pack == 'serenite' || this.pack == 'confort'">
                              <div class="row">
                                <div class="col-sm-12">
                                  <div class="wizard-tab-content">
                                      <div role="tabpanel" id="zone_mobile" aria-hidden="true" aria-labelledby="step-zone_mobile" class="wizard-tab-container">
                                        <div>
                                          <div class="fields">
                                            <div class="field-subtitle mb-0" style="font-size:20px!important">
                                              {{$t('devis.devis_sante.assur_care.zone_couverture_label')}}
                                            </div>
                                          </div>

                                            <div class="fields">
                                            <div class="row">
                                              <div class="col-sm-12" v-for="item in zoneList" :key="item">
                                                <div class="mt-2 btn-choice">
                                                    <input @change="calculPrimeZone()" v-model="zone" type="radio" :value="item.value" :id="item.name" name="zone_mobile" class="field-input">
                                                    <label :for="item.name" class="field-label btn-choice-hide-dot" style="padding: 8px!important">
                                                      <span>{{item.name}}</span>
                                                      <div class="wizard-tab-content" style="margin-top: -15px!important;">
                                                        <div role="tabpanel" id="choix_zone_mobile" aria-hidden="true" aria-labelledby="step-choix_zone_mobile" class="wizard-tab-container">
                                                          <div>
                                                            <div class="fields">
                                                              <div class="justify-center field-title mb-0">
                                                                <span style="color:#ffa409;font-weight:600">{{ item.prix.toLocaleString() }} FCFA</span> 
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </label>
                                                  </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                              </div>
                            </div>

                          <v-divider></v-divider>

                          <div class="wizard-tab-content">
                            <div role="tabpanel" id="prix_mobile" aria-hidden="true" aria-labelledby="step-prix_mobile" class="wizard-tab-container">
                              <div>
                                <div class="fields">
                                  <div class="justify-center field-subtitle mb-0" style="font-size:20px!important">
                                    {{$t('devis.devis_sante.assur_care.nombre_assure_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ AllAssure }} pers</span><br/>
                                    {{$t('devis.devis_sante.assur_care.total_pack_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ ttc.toLocaleString() }} FCFA</span> 
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="BacktoFirstStep()" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          {{$t('devis.devis_sante.assur_care.bouton_retour_label')}}
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="nextStepToOption()" type="button" class="wizard-btn">
                          {{$t('devis.devis_sante.assur_care.bouton_suivant_label')}}
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>

                  <div class="page" v-show="step === 3">
                    <div class="wizard-tab-content">
                      <div role="tabpanel" id="Step8_mobile" aria-hidden="true" aria-labelledby="step-Step8_mobile" class="wizard-tab-container">
                        <div>
                          <div class="loan-group loan-group-0">
                            <div class="fields">
                              <div class="fields">
                                <div data-v-0d43d413="" class="field-subtitle mb-0 row justify-content-center" style="font-size:20px!important">
                                  {{$t('devis.devis_sante.assur_care.titre_stepr_4')}}
                                </div>
                                <!-- <div class="field-title font-weight-bold">{{$t('devis.devis_sante.assur_care.titre_stepr_4')}}</div> -->
                                <div class="mt-3 justify-content-center row">
                                  <div class="souscrip_switch">
                                    <input v-model="ContractantFields.Genre" value="homme" type="radio" id="monsieur_mobile" name="genre_situa_mobile" /><label for="monsieur_mobile">{{$t('devis.devis_sante.assur_care.souscripteur_form.monsieur_label')}}</label>
                                    <input v-model="ContractantFields.Genre" value="femme" type="radio" id="madame_mobile" name="genre_situa_mobile" /><label for="madame_mobile">{{$t('devis.devis_sante.assur_care.souscripteur_form.madame_label')}}</label>
                                  </div>
                                  <div class="souscrip_switch ml-3 mt-2">
                                    <input v-model="ContractantFields.Situation" value="marié" type="radio" id="marié_mobile" name="matri_situa_mobile" /><label for="marié_mobile">{{$t('devis.devis_sante.assur_care.souscripteur_form.marie_label')}}</label>
                                    <input v-model="ContractantFields.Situation" value="célibataire" type="radio" id="celi_mobile" name="matri_situa_mobile" /><label for="celi_mobile">{{$t('devis.devis_sante.assur_care.souscripteur_form.celibat_label')}}</label>
                                  </div>
                                </div>
                                <div class="mt-4 row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.nom_label')}}</label>
                                      <input v-model="ContractantFields.Nom" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.nom_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.prenom_label')}}</label>
                                      <input v-model="ContractantFields.Prenom" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.prenom_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default">
                                      <label for="Stepper25" class="field-label">
                                        {{$t('devis.devis_sante.assur_care.souscripteur_form.date_naissance_label')}}
                                        <!---->
                                      </label>
                                      <div class="input-group value-loan">
                                        <date-picker class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.date_naissance_placeholder')" id="Stepper25" @change="yearsDiffContractant()" v-model="ContractantFields.dateNaissance" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4 row">
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.lieu_naissance_label')}}</label>
                                      <input v-model="ContractantFields.LieuNaissance" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.lieu_naissance_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default mb-4 mb-sm-0">
                                      <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.telephone_label')}}</label>
                                      <input @keypress="onlyNumber" v-model="ContractantFields.Telephone" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.telephone_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                      <div id="error">{{ errors.phone }}</div>
                                    </div>
                                  </div>
                                  <div class="col-sm-4">
                                    <div class="field-group field-default">
                                      <label for="Stepper28" class="field-label">{{$t('devis.devis_sante.assur_care.souscripteur_form.email_label')}}</label>
                                      <input v-model="ContractantFields.Email" :placeholder="$t('devis.devis_sante.assur_care.souscripteur_form.email_placeholder')" id="Stepper28" name="Step8" class="field-input">
                                      <div id="error">{{ errors.email }}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="BacktoSecondStep()" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          {{$t('devis.devis_sante.assur_care.bouton_retour_label')}}
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button @click="ContractControl()" type="button" class="wizard-btn">
                          {{$t('devis.devis_sante.assur_care.bouton_suivant_label')}}
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>

                  <div class="page review_page" v-show="step === 4">
                    <div data-v-221edead="" class="w-100 Results" pricing="true" >
                      <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="wizard-tab-container">
                        <div data-v-0d43d413="">
                          <div data-v-0d43d413="" class="fields">
                            <div data-v-0d43d413="" class="field-subtitle mb-0 row justify-content-center" style="font-size:20px!important">
                              {{$t('devis.devis_sante.assur_care.titre_stepr_5')}}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div data-v-221edead="">
                        <div data-v-221edead="" class="results-deals">
                          <div data-v-221edead="" id="results-table">
                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                              <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                <div data-v-221edead="" class="card-default-body">
                                  <h1 class="field-title row justify-content-center">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.title')}}</h1>
                                  <div data-v-221edead="" class="logo-company logo-company-economy">
                                    <ul class="to-left policeLato">
                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.genre_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Genre}}</span>
                                      </li>

                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.situation_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Situation}}</span>
                                      </li>

                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.nom_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Nom}}</span>
                                      </li>

                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.prenom_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Prenom}}</span>
                                      </li>

                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.date_naissance_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{DateFormater(ContractantFields.dateNaissance)}}</span>
                                      </li>

                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.lieu_naissance_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.LieuNaissance}}</span>
                                      </li>

                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.telephone_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Telephone}}</span>
                                      </li>

                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.souscripteur.email_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{ContractantFields.Email}}</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div data-v-221edead="">
                        <div data-v-221edead="" class="results-deals">
                          <div data-v-221edead="" id="results-table">
                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                              <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                <div data-v-221edead="" class="card-default-body">
                                  <h1 class="field-title row justify-content-center">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.title')}}</h1>
                                  <div data-v-221edead="" class="logo-company logo-company-economy">
                                    <ul class="to-left policeLato">
                                      <p class="font-weight-bold" v-if="this.adulteTotal > 0">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.adulte_label')}}</p>
                                      <li class="field-sub-title" v-if="this.nbreAdulteHomme > 0">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.homme_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{nbreAdulteHomme}}</span>
                                      </li>

                                      <li class="mt-3 field-sub-title" v-if="this.nbreAdulteFemme > 0">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.femme_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{nbreAdulteFemme}}</span>
                                      </li>

                                      <p class="mt-3 font-weight-bold" v-if="this.enfantTotal > 0">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.enfant_label')}}</p>
                                      <li class="field-sub-title" v-if="this.nbreEnfantGarcon > 0">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.garcon_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{nbreEnfantGarcon}}</span>
                                      </li>

                                      <li class="mt-3 field-sub-title" v-if="this.nbreEnfantFille > 0">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.fille_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{nbreEnfantFille}}</span>
                                      </li>

                                      <p class="font-weight-bold mt-3" v-if="this.isSenior">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.senior_label')}}</p>
                                      <li class="field-sub-title" v-if="isSenior">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.homme_senior_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{nbreSeniorHomme}}</span>
                                      </li>

                                      <li class="mt-3 field-sub-title" v-if="isSenior">{{$t('devis.devis_sante.assur_care.detail_assurance_step.assure.femme_senior_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right">{{nbreSeniorFemme}}</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div data-v-221edead="">
                        <div data-v-221edead="" class="results-deals">
                          <div data-v-221edead="" id="results-table">
                            <div data-v-221edead="" style="top: 0px; width: 100%;">
                              <div data-v-221edead="" class="card-default result text-center naoassur elevation-10">
                                <div data-v-221edead="" class="card-default-body">
                                  <h1 class="field-title row justify-content-center">{{$t('devis.devis_sante.assur_care.detail_assurance_step.garantie.title')}}</h1>
                                  <div data-v-221edead="" class="logo-company logo-company-economy">
                                    <ul class="to-left policeLato">
                                      <p style="margin-bottom: -3px" class="font-weight-bold">{{$t('devis.devis_sante.assur_care.detail_assurance_step.garantie.pack_choice_label')}}</p>
                                      <li class="field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.garantie.nom_pack_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right" v-if="this.pack == 'essentiel'">{{packBasic.nomPack}}</span>
                                        <span class="font-weight-bold field-sub-title to-right" v-if="this.pack == 'serenite'">{{packEssentiel.nomPack}}</span>
                                        <span class="font-weight-bold field-sub-title to-right" v-if="this.pack == 'confort'">{{packConfort.nomPack}}</span>
                                      </li>

                                      <li class="to-left field-sub-title">{{$t('devis.devis_sante.assur_care.detail_assurance_step.garantie.prix_base_label')}} :
                                        <span class="font-weight-bold field-sub-title to-right" v-if="this.pack == 'essentiel'">{{packBasic.prix}}</span>
                                        <span class="font-weight-bold field-sub-title to-right" v-if="this.pack == 'serenite'">{{packEssentiel.prix}}</span>
                                        <span class="font-weight-bold field-sub-title to-right" v-if="this.pack == 'confort'">{{packConfort.prix}}</span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto" class="mt-3 wizard-tab-container">
                        <div data-v-0d43d413="">
                          <div data-v-0d43d413="" class="fields mt-3">
                            <div data-v-0d43d413="" class="field-subtitle mb-0 row justify-content-center" style="font-size:20px!important">
                              {{ $t('devis.devis_auto.choix_assureurs') }}
                            </div>

                                <div class="insurers-grid">
                                                                                <!-- Bouton "Tous" -->
                                                                                <div class="insurer-card all-insurers" :class="{ 'selected': selectAll }">
                                                                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="insurer-input">
                                                                                  <label for="tous_mobile" class="insurer-label">
                                                                                    <div class="insurer-icon">
                                                                                      <img src="../assets/img/icones/all.png" alt="Tous les assureurs" class="insurer-logo">
                                                                                    </div>
                                                                                    <div class="insurer-info">
                                                                                      <h4 class="insurer-name">{{ $t('devis.devis_auto.bouton_tous') }}</h4>
                                                                                      <span class="insurer-badge">Tous</span>
                                                                                    </div>
                                                                                    <div class="selection-indicator">
                                                                                      <i class="fas fa-check"></i>
                                                                                    </div>
                                                                                  </label>
                                                                                </div>
                                                
                                                                                <!-- Cartes des assureurs -->
                                                                                <div 
                                                                                  class="insurer-card" 
                                                                                  v-for="assure in listeAssureurs" 
                                                                                  :key="assure._id"
                                                                                  :class="{ 'selected': assureurs.includes(assure.societe) }"
                                                                                >
                                                                                  <input 
                                                                                    v-model="assureurs" 
                                                                                    type="checkbox" 
                                                                                    :value="assure.societe" 
                                                                                    :id="assure.societe"
                                                                                    class="insurer-input"
                                                                                  >
                                                                                  <label :for="assure.societe" class="insurer-label">
                                                                                    <div class="insurer-icon">
                                                                                      <img :src="assure.logo" :alt="assure.societe" class="insurer-logo">
                                                                                    </div>
                                                                                    <div class="insurer-info">
                                                                                      <h4 class="insurer-name">{{ assure.societe }}</h4>
                                                                                      <span class="insurer-badge">Assureur</span>
                                                                                    </div>
                                                                                    <div class="selection-indicator">
                                                                                      <i class="fas fa-check"></i>
                                                                                    </div>
                                                                                  </label>
                                                                                </div>
                                                                              </div>
                                                
                                                                              <!-- Résumé de la sélection -->
                                                                              <div class="selection-summary" v-if="assureurs.length > 0">
                                                                                <div class="summary-content">
                                                                                  <i class="fas fa-info-circle"></i>
                                                                                  <span>{{ assureurs.length }} {{ $t('devis.devis_auto.assureur_label') }}{{ assureurs.length > 1 ? 's' : '' }} {{ $t('devis.devis_auto.selectionne_label') }}{{ assureurs.length > 1 ? 's' : '' }}</span>
                                                                                </div>
                                                                              </div>
                                <!-- <div class="btn-choice col-sm-3 col-4">
                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="field-input">
                                  <label for="tous_mobile" class="field-label" label="Tous">
                                    <img src="../assets/img/icones/all.png" alt="Tous_mobile" height="60" width="60">
                                    <p class="field-title" style="margin-top:-12px;margin-bottom:-10px;color:#ffa409">{{
                                      $t('devis.devis_auto.bouton_tous') }}</p>
                                  </label>
                                </div> -->
                                <!-- <div class="btn-choice col-sm-6 col-6" v-for="assure in listeAssureurs" :key="assure._id">
                                  <input v-model="assureurs" type="checkbox" :value="assure.societe" :id="assure.societe"
                                    class="field-input">
                                  <label :for="assure.societe" class="field-label" :label="assure.societe">
                                    <img :src="assure.logo" :alt="assure.societe" height="50">
                                    <p class="field-title" style="margin-top:-3px;margin-bottom:-10px">
                                      {{ assure.societe }}</p>
                                  </label>
                                </div> -->
                             

                            <div data-v-0d43d413="" class="field-subtitle mb-0 row justify-content-center" style="font-size:20px!important">
                              {{$t('devis.devis_sante.assur_care.detail_assurance_step.periode.title')}}
                            </div>

                            <div class="row">
                              <div class="col-sm-6">
                                <div class="field-group field-default mb-4 mb-sm-0">
                                  <label for="Stepper39_mobile" class="field-label">{{$t('devis.devis_sante.assur_care.detail_assurance_step.periode.date_effet')}}
                                    <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                  <div class="input-group rate-loan">
                                    <date-picker id="Stepper39_mobile" :disabled-date="disabledBeforeToday" class="field-input ml-2 mb-1 mt-1" :placeholder="$t('devis.devis_sante.assur_care.detail_assurance_step.periode.date_effet_placeholder')" @change="dateDiff()" :min="new Date().toISOString().substr(0, 10)" v-model="dateEffet" valueType="format" format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                  </div>
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <div class="field-group field-default mb-4 mb-sm-0">
                                  <label for="Stepper40_mobile" class="field-label">{{$t('devis.devis_sante.assur_care.detail_assurance_step.periode.date_echeance')}}
                                    <button type="button" tabindex="-1" title="" class="field-help" data-original-title="Taux d'intérêt"></button></label>
                                  <div class="input-group rate-loan">
                                    <input disabled :placeholder="$t('devis.devis_sante.assur_care.detail_assurance_step.periode.date_echeance_placeholder')" v-model="dateEcheance" id="Stepper40_mobile" name="Step11" class="field-input">
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="fields">
                              <div class="field-group row flex-column flex-sm-row">
                                <div class="justify-content-center row ml-3 mr-3">
                                  <div class="wizard-tab-content">
                                    <div role="tabpanel" id="enfant_assure" aria-hidden="true" aria-labelledby="step-enfant_assure" class="wizard-tab-container">
                                      <div>
                                        <div class="fields" style="font-size:20px!important">
                                          <div class="justify-center field-subtitle mb-0">
                                            {{$t('devis.devis_sante.assur_care.nombre_assure_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ AllAssure }} personnes</span>
                                          </div>

                                          <div v-if="totalHorsTaxe !== null && this.totalHorsTaxe == 0" class="justify-center field-subtitle mb-0">
                                            {{$t('devis.devis_sante.assur_care.prime_nette_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ prixNetTotal.toLocaleString() }} FCFA</span>
                                          </div>

                                           <div v-if="frais !== null" class="justify-center field-subtitle mb-0">
                                            {{$t('devis.devis_sante.assur_care.accessoire_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ frais.toLocaleString() }} FCFA</span>
                                          </div>

                                           <div v-if="taxe !== null" class="justify-center field-subtitle mb-0">
                                            {{$t('devis.devis_sante.assur_care.taxe_label')}} : <span style="float:right;color:#ffa409;font-weight:600">{{ taxe.toLocaleString() }} FCFA</span>
                                          </div>
                                          <div v-if="zone !== null" class="justify-center field-subtitle mb-0">
                                            Zone : <span style="float:right;color:#ffa409;font-weight:600">{{ zone }}</span>
                                          </div>

                                          <div v-if="ttc !== null" class="justify-center field-subtitle mb-0">
                                            {{$t('devis.devis_sante.assur_care.prime_total_label')}} : <span style="float:right;color:#5B94BC;font-weight:600">{{ ttc.toLocaleString() }} FCFA</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wizard-card-footer clearfix">
                      <div class="wizard-footer-left">
                        <button @click="BacktoThirstStep()" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          {{$t('devis.devis_sante.assur_care.bouton_retour_label')}}
                        </button>
                      </div>
                      <div class="wizard-footer-right">
                        <button :disabled="disabledButtonValidate" @click="CreateDevis()" type="button" class="wizard-btn">
                          {{$t('devis.devis_sante.assur_care.bouton_suivant_label')}}
                        </button>
                      </div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ========= DIALOG DETAILS PACKS ============ -->
    <!-- ========= DIALOG DETAILS PACKS ============ -->
    <v-dialog v-model="detailsPopup" width="500" scrollable>
      <v-card elevation="24" class="border-radius">
        <v-card-text style="background:#FAFAFA">
          <div class="wizard-tab-content">
            <div role="tabpanel" id="Popup_autre" aria-hidden="true" aria-labelledby="step-Popup_autre" class="wizard-tab-container">
              <div>
                <div class="loan-group loan-group-0">
                  <div class="fields">
                    <div class="field-title font-weight-bold">Détail du pack</div>
                    <div class="row" v-if="packOffreSante === 'pack_essentiel'">
                      <div class="col-sm-6">
                        <div class="field-group field-default">
                          <label class="field-label">10 pers. minimum</label>
                          <label class="field-label" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.pack_essentiel_content.avantages')}}</label>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[0]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[1]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[2]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[3]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_avantage[4]')}}
                        </div>
                      </div>
                      <div class="col-sm-6 mt-2">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <label class="field-label" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.pack_essentiel_content.condition_mobile')}}</label>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_condition[0]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_condition[1]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_condition[2]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_essentiel_content.content_condition[3]')}}
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="packOffreSante === 'pack_serenite'">
                      <div class="col-sm-6">
                        <div class="field-group field-default">
                          <label class="field-label" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.pack_serenite_content.avantages')}}</label>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[0]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[1]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[2]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[3]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[4]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[5]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_avantage[6]')}}
                        </div>
                      </div>
                      <div class="col-sm-6 mt-2">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <label class="field-label" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.pack_serenite_content.condition_mobile')}}</label>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[0]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[1]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[2]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[3]')}} <br>
                          <span class="font-weight-bold">{{$t('devis.devis_sante.assur_care.pack_serenite_content.content_condition[4]')}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="packOffreSante === 'pack_confort'">
                      <div class="col-sm-6">
                        <div class="field-group field-default">
                          <label class="field-label" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.pack_confort_content.avantages')}}</label>
                          {{$t('devis.devis_sante.assur_care.pack_confort_content.content_avantage[0]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_confort_content.content_avantage[1]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_confort_content.content_avantage[2]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_confort_content.content_avantage[3]')}}
                        </div>
                      </div>
                      <div class="col-sm-6 mt-2">
                        <div class="field-group field-default mb-4 mb-sm-0">
                          <label class="field-label" style="color: #ffa409">{{$t('devis.devis_sante.assur_care.pack_confort_content.condition_mobile')}}</label>
                          {{$t('devis.devis_sante.assur_care.pack_confort_content.content_condition[0]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_confort_content.content_condition[1]')}}<br>
                          {{$t('devis.devis_sante.assur_care.pack_confort_content.content_condition[2]')}}<br>
                          <span class="font-weight-bold">{{$t('devis.devis_sante.assur_care.pack_confort_content.content_condition[3]')}}</span>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="wizard-card-footer clearfix">
                    <div class="wizard-footer-left">
                        <button @click="detailsPopup = false" type="button" class="wizard-btn">
                          <span class="fas fa-arrow-left"></span>
                          {{$t('devis.devis_sante.assur_care.bouton_fermer_label')}}
                        </button>
                      <!--//-->
                    </div>
                    <div class="wizard-footer-right">
                       <!--//-->
                    </div>
                    <!---->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{$t('devis.devis_sante.assur_care.devis_encours')}}</span>
    </div>

    <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                <div class="wizard-tab-content" style="background:#FFA409">
                    <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                    <div>
                        <div class="loan-group loan-group-0" style="background:#FFA409">
                        <div class="fields text-center" style="background:#FFA409">
                            <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular> 
                            <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_sante.assur_care.devis_encours')}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </v-card-text>
            </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
        <v-card elevation="24" class="border-radius">
        <v-card-text style="background:#FFA409">
            <div class="wizard-tab-content" style="background:#FFA409">
            <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso" class="wizard-tab-container">
                <div>
                <div class="loan-group loan-group-0" style="background:#FFA409">
                    <div class="fields text-center" style="background:#FFA409">
                        <span class="field-title font-weight-bold" style="color:#fff">{{$t('devis.devis_sante.assur_care.devis_encours')}}</span>
                    </div>
                    <div class="fields text-center" style="background:#FFA409">
                        <v-progress-circular size="50" color="white" class="mr-2" indeterminate></v-progress-circular>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </v-card-text>
        </v-card>
    </v-dialog> -->

    <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
    <login-form :visible="showLoginForm" @close="showLoginForm=false"></login-form>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Api from '../services/Api'
import store from '../store/store'
import LoginForm from './auth/Login'
import {
  mask
} from 'vue-the-mask'
import MedicalQuestion from "@/common/questionnaire_medical_assurcare.json";

const validateEmail = email => {
  if (!email.length) {
    return {valide: false, error: "L'adresse mail est obligatoire!"};
  } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
    return { valide: false, error: "Veuillez entrer un email valide!" };
  } else {
    return { valide: true, error: null };
  }
};

const validatePhone = phone => {

  if(!phone.length){
    return { valide: false, error: 'Le numéro de téléphone est obligatoire.' };
  }else if (phone.length < 9) {
    return { valide: false, error: 'Le numéro de téléphone doit contenir 9 chiffres au minimum.' };
  }else{
    return { valide: true, error: null };
  }
};

export default {
  name: 'Auto',
  components: {
    LoginForm
  },
  directives: {
    mask,
  },
  data() {
    return {
      prixSenegal : 0,
      prixAfrique : 0,
      prixEurope : 0,
      prixMonde : 0,
      zone : null,
      zoneList: [
          {
              name: 'Sénégal',
              value: 'Senegal',
              prix : 0,
              img: require('../assets/img/assurcare/senegal.png'),
              alt :'senegal'
          },
          {
              name: 'Afrique',
              value: 'Afrique',
              prix : 0,
              img: require('../assets/img/assurcare/afrique.png'),
              alt :'afrique'
          },
          {
              name: 'Afrique + UE',
              value: 'Europe',
              prix : 0,
              img: require('../assets/img/assurcare/europe.png'),
              alt :'europe'
          },
          {
              name: 'Monde (Hors USA)',
              value: 'Monde',
              prix : 0,
              img: require('../assets/img/assurcare/monde.png'),
              alt :'monde'
          }
        ],
      dialogLoading : false,
      disabledButtonValidate : false,
      detailsPopup :  false,
      bottomPushNotif : false,
      showAdulte : true,
      showEnfant : true,
      showSenior : true,
      ageAssure : null,
      disabled_checkbox : false,
      foundForHomme : null,
      foundForFemme : null,
      foundForGarcon : null,
      foundForFille : null,
      foundForHommeSenior : null,
      foundForFemmeSenior :null,
      basic_pack_price:null,
      dateEffet:null,
      dateEcheance:null,
      money: {
        thousands: ' ',
        precision: false,
        masked: false,
        suffix: ' FCFA'
      },
      disabled_homme : false,
      disabled_femme : false,
      disabled_garcon : false,
      disabled_fille : false,
      disabled_homme_senior :false,
      disabled_femme_senior : false,
      totalHorsTaxe : 0,
      ttc : 0,
      pdfBasic : false,
      pdfEssentiel : false,
      pdfConfort : false,
      frais: 0,
      taxe : 0,
      disabled_dentaire : false,
      disabled_optique : false,
      packOffreSante: null,
      HideNbVehicule : true,
      nombreAssures : null,
      itemsFlotte: ['2', '3', '4'],
      valeur_venale :  null,
      immatriculation : null,
      nbAssureAdded : 0,
      ListAssure : [],
      prixTotalOptions : 0,
      AllAssure : 0,
      errors: {},
      activeStep: 0,
      isContractant: true,
      isAssure : false,
      // Contractant fields
      ContractantFields: {
        Cni: null,
        Genre: null,
        Situation: null,
        Nom: null,
        Prenom: null,
        dateNaissance: null,
        LieuNaissance: null,
        Telephone: null,
        Email: null
      },
      // Assure fields
      AssureFields: {
        Nom: null,
        Prenom: null,
        dateNaissance: null,
        CNI :null,
        age : null,
      },
      formSteps: [
        {
          title: "SOUSCRIPTEUR",
          fields: [
            { valid: true },
          ]
        },
        {
          title: "ASSURE(S)",
          fields: [
            { valid: true },
          ]
        }
      ],
      questions:[
        {num:1, q:'votre taille'},
        {num:2, q:'votre poids'},
        {num:3, q:'votre nom'},
        {num:4, q:'votre prenom'}
      ],
      customers:[
        {
          nom:'Mowen',
          prenom:'Cleopas',
          questions:[
            {num:1, q:'votre taille', reponse:''},
            {num:2, q:'votre poids', reponse:''},
            {num:3, q:'votre nom', reponse:''},
            {num:4, q:'votre prenom', reponse:''}
          ]
        },
        {
          nom:'Mowen',
          prenom:'Melissa',
          questions:[
            {num:1, q:'votre taille', reponse:''},
            {num:2, q:'votre poids', reponse:''},
            {num:3, q:'votre nom', reponse:''},
            {num:4, q:'votre prenom', reponse:''}
          ]
        },
        {
          nom:'Mowen',
          prenom:'Berion',
          questions:[
            {num:1, q:'votre taille', reponse:''},
            {num:2, q:'votre poids', reponse:''},
            {num:3, q:'votre nom', reponse:''},
            {num:4, q:'votre prenom', reponse:''}
          ]
        },
        {
          nom:'Mowen',
          prenom:'Weenie',
          questions:[
            {num:1, q:'votre taille', reponse:''},
            {num:2, q:'votre poids', reponse:''},
            {num:3, q:'votre nom', reponse:''},
            {num:4, q:'votre prenom', reponse:''}
          ]
        }
      ],
      fraisDentaire : null,
      fraisOptique: null,
      maternite : null,
      isMaternite : false,
      isDentaire : false,
      isOptique : false,
      prixDessusTrois: 100000,
      prixDessusTroisSenior : 225000,
      prixNetTotal : 0,
      firstMajor : 0,
      secondMajor : 0,
      thirstMajor : 0,
      fourtMajor : 0,
      isBasic : false,
      isEssentiel : false,
      isConfort : false,
      basic : null,
      essentiel: null,
      confort: null,
      pack:null,
      packBasic : {
        nomPack : 'Essentiel 70%',
        prix: 150000,
      },
      packEssentiel : {
        nomPack : 'Sérénité 80%',
        prix :  290000
      },
      packConfort : {
        nomPack : 'Confort 90%',
        prix: 370000
      },
      optionMaternite : {
        num : 1,
        nom : 'Maternite',
        prix : 100000
      },
      optionDentaire : {
        num : 2,
        nom : 'Frais dentaire',
        prix : 50000
      },
      optionOptique : {
        num : 2,
        nom : 'Frais optique',
        prix : 50000
      },
      datePickerAssureBirth : false,
      dateNaissance : null,
      age : '',
      listAssure: [],
      nbassure: null,
      ChangeAgeAssure: false,
      adulte_enfant: null,
      prixNetforAdulte: 0,
      prixNetforEnfant: 0,
      prixNetforSenior : 0,
      nbreAdulteHomme : 0,
      nbreAdulteFemme : 0,
      nbreEnfantGarcon : 0,
      nbreEnfantFille : 0,
      nbreSeniorHomme : 0,
      nbreSeniorFemme : 0,
      total : null,
      adulteTotal : null,
      enfantTotal :  null,
      seniorTotal :  null,
      isSenior: false,
      isHidden : true,
      genre: null,
      elevation: 2,
      supplementPreventionSiHomme: 175000,
      supplementPreventionSiFomme: 57000,
      sagefemme: false,
      dialogSageFemme: false,
      btnnext: null,
      dialog1: false,
      dialog: false,
      testDialo: false,
      optionPrevention: false,
      packChoisis: [],
      listPack: [],
      options : [],
      optionCardio: false,
      datePickerEffet: false,
      checkbox: false,
      payement: null,
      items: ['2', '3'],
      ToastTabSucess: {  // Customized options for success toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'info',
        className: 'custom-success-class'
      },
      ToastTabError: {  // Customized options for error toast
        theme: "toasted-primary",
        position: "top-center",
        duration: 7000,
        fitToScreen: true,
        type: 'error'
      },
      step:1,
      showLoginForm: false,
      suivant: false,
      listeAssureurs : [],
      assureurs: [],
      selected: [],
    }
  },
  methods: {
    checkToken() {
        Api().get('user/check/token')
        .then((resultat) => {
          // verifie si le token exist
          if (!resultat.data.ok) {
            store.state.isUserLoggedIn = false;
            store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          }).catch((err) => {
            // verifie  si le token est expiré
            if(err.response.data.ok === false){
              store.state.isUserLoggedIn = false;
              store.dispatch("setUser", {});
              store.dispatch("setToken", {});
              this.showLoginForm = true
            }
          });
    },
    /*=================Recuperation des partenaires assureurs==============*/
    getListePartenaire: function () {
        Api().get('partenaire/partners/auto')
            .then(response => {
            this.listeAssureurs = response.data.partenaires.filter(assureur => assureur.societe === 'SANLAMALLIANZ' || assureur.societe === 'AXA');
            console.log(this.listeAssureurs)
          })
      },
    /*=================Creation d'une liste de vehicules pour affichage Recap===============*/
    ShowDetailsPack(){
      if(this.packOffreSante === 'pack_essentiel' || this.packOffreSante === 'pack_serenite' || this.packOffreSante === 'pack_confort') {
        document.getElementById("testResize").classList.add('col-lg-8');
        document.getElementById('card_width_basic').classList.add('card_width')
        document.getElementById('card_width_essentiel').classList.add('card_width')
        document.getElementById('card_width_confort').classList.add('card_width')
        document.getElementById('img_margin_top').classList.add('img_margin_top')
        this.showSideBar = true
      }else {
        document.getElementById("testResize").classList.remove('col-lg-8');
        document.getElementById('card_width_basic').classList.remove('card_width')
        document.getElementById('card_width_essentiel').classList.remove('card_width')
        document.getElementById('card_width_confort').classList.remove('card_width')
      }
    },

    disabledBeforeToday(date) {
      const today = new Date();
      return date < today;
    },
    disabledAfterToday(date){
      const today = new Date()
      return date > today
    },

    yearsDiffAssure() {
      const date1 = dayjs(this.AssureFields.dateNaissance);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');
      this.ageAssure = daydiff;

      if (this.ageAssure < 0) {
        this.ageAssure = null;
        this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
        this.AssureFields.dateNaissance = null
      }
      if(this.pack == 'essentiel' || this.pack == 'serenite' || this.pack == "confort"){
        if (this.ageAssure) {
          let year = Math.floor(this.ageAssure / 360);
          this.ageAssure = year;
        }
      }
    },

    dateDiff: function () {
      if (this.dateEffet === '' && this.duree === '') this.dateEcheance = '';
      let inter = dayjs(this.dateEffet).add(1, 'year').format('YYYY-MM-DD');
      this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
    },

    calculTTC (){
      if(this.pack == 'essentiel'){
        this.ttc = (this.prixNetTotal + this.frais + this.taxe)
      }else if(this.pack == 'serenite' || this.pack == 'confort'){
          // ------------- MAJORATION HORS SENEGAL ------------------
          //this.ttc = (this.prixNetTotal + this.frais + this.taxe)
          for(let p of this.zoneList){
            if(p.value == 'Senegal'){
              // ------------- Majoration Senegal -----------------
              p.prix = this.prixNetTotal
              this.prixSenegal = (p.prix + this.frais + this.taxe)
            }
            if(p.value == 'Afrique'){
              // ------------- Majoration Afrique ------------------
              p.prix = this.prixNetTotal + (this.prixNetTotal * 0.2)
              this.prixAfrique = (p.prix + this.frais + this.taxe)
            }
            if(p.value == 'Europe'){
              // ------------- Majoration Europe ------------------
              p.prix = this.prixNetTotal + (this.prixNetTotal * 0.3)
              this.prixEurope = (p.prix + this.frais + this.taxe)
            }
            if(p.value == 'Monde'){
              // ------------- Majoration Monde ------------------
              p.prix = this.prixNetTotal + (this.prixNetTotal * 0.5)
              this.prixMonde = (p.prix + this.frais + this.taxe)
            }
          }
      }
    },

    calculPrimeZone(){
      if(this.zone == 'Senegal'){
        this.ttc = this.prixSenegal;
      } else if(this.zone == 'Afrique'){
        this.ttc = this.prixAfrique;
      } else if(this.zone == 'Europe'){
        this.ttc = this.prixEurope
      } else if(this.zone == 'Monde'){
        this.ttc = this.prixMonde
      }
    },

    calculPrimeHorsTaxe(){
      this.totalHorsTaxe = this.prixNetTotal + this.prixTotalOptions
    },

    calculTaxe(){
      if(this.AllAssure > 0){
        if(this.pack == 'essentiel'){
          this.frais = 25000;
          this.taxe = (this.prixNetTotal + this.frais) * 0.14
        }else if(this.pack == 'confort' || this.pack == 'serenite'){
          this.frais = 10000;
          this.taxe = (this.prixNetTotal + this.frais) * 0.14
        }
      }else {
        this.frais = 0
        this.ttc = 0
        this.taxe = 0
      }
     
    },

    openPdfBasic(){
      this.dialog = true,
          this.pdfBasic = true,
          this.pdfEssentiel = false
      this.pdfConfort = false
    },

    openPdfEssentiel(){
      this.dialog = true,
          this.pdfBasic = false,
          this.pdfEssentiel = true
      this.pdfConfort = false
    },

    openPdfConfort(){
      this.dialog = true,
          this.pdfBasic = false,
          this.pdfEssentiel = false
      this.pdfConfort = true
    },

    getPrixOption(){
      let Totale = this.adulteTotal + this.enfantTotal + this.seniorTotal
      let maternite = this.nbreAdulteFemme
      let firstOption = this.optionDentaire.prix * Totale
      let secondOption = this.optionOptique.prix * Totale
      //let thirtOption = this.optionMaternite.prix * maternite

      let thirtOption = this.optionMaternite.prix * maternite
      let Total = firstOption + secondOption

      if(this.fraisOptique){
        this.prixTotalOptions = secondOption
      }else if(this.fraisDentaire){
        this.prixTotalOptions = firstOption
      }else if(this.maternite){
        this.prixTotalOptions = thirtOption
      } else {
        this.prixTotalOptions = 0
      }

      if(this.fraisDentaire && this.fraisOptique){
        this.prixTotalOptions = Total
      }else if(this.fraisDentaire && this.maternite){
        this.prixTotalOptions = firstOption + thirtOption
      }else if(this.fraisOptique && this.maternite){
        this.prixTotalOptions = secondOption + thirtOption
      }

      if(this.fraisDentaire && this.fraisOptique && this.maternite){
        this.prixTotalOptions = firstOption + secondOption + thirtOption
      }
    },


    getHommeAssure()
    {
      if(this.AssureFields.age == 'Adulte_femme'){
        this.foundForFemme++
      }

      if(this.AssureFields.age == 'Adulte_homme') {
        this.foundForHomme++
      }

      if(this.AssureFields.age == 'garcon') {
        this.foundForGarcon++
      }

      if(this.AssureFields.age == 'fille') {
        this.foundForFille++
      }

      if(this.AssureFields.age == 'homme') {
        this.foundForHommeSenior++
      }

      if(this.AssureFields.age == 'femme'){
        this.foundForFemmeSenior++
      }

      if(this.foundForHomme == this.nbreAdulteHomme){
        this.disabled_homme = true
      }

      if(this.foundForFemme ==  this.nbreAdulteFemme){
        this.disabled_femme = true
      }

      if(this.foundForGarcon ==  this.nbreEnfantGarcon){
        this.disabled_garcon = true
      }

      if(this.foundForFille ==  this.nbreEnfantFille){
        this.disabled_fille = true
      }

      if(this.foundForHommeSenior == this.nbreSeniorHomme){
        this.disabled_homme_senior = true
      }

      if(this.foundForFemmeSenior == this.nbreSeniorFemme){
        this.disabled_femme_senior = true
      }

    },


    /*=================Creation d'une liste de vehicules pour affichage Recap===============*/
    CreateListAssure () {
      if(this.AssureFields.Nom && this.AssureFields.Prenom && this.AssureFields.dateNaissance && this.AssureFields.age){
        const Assure = {
          Nom: this.AssureFields.Nom,
          Prenom : this.AssureFields.Prenom,
          DateNaissance : this.AssureFields.dateNaissance,
          CNI : this.AssureFields.CNI,
          Age :  this.AssureFields.age,
          Homme : this.nbreAdulteHomme,
          Femme : this.nbreAdulteFemme
        };


        if(this.AssureFields.age == 'garcon' || this.AssureFields.age == 'fille'){
          if(this.ageAssure <= 21){
            this.ListAssure.push(Assure);
            this.getHommeAssure()
            this.nbAssureAdded = this.nbAssureAdded + 1;

            if (this.nombreAssures > 0) {
              if (this.nbAssureAdded < this.nombreAssures) {
                this.$toasted.show('Ajouté avec succes! ', this.ToastTabSucess)
                this.ClearFormAssure();
                this.disableDateAssure =  false
              }
              if (this.nbAssureAdded == this.nombreAssures) {
                this.e1 = 6
              }
            }else {
              this.voidField = true
            }
          }else {
            this.$toasted.show('Date de naissance choisie ne correspond pas à un enfant !', this.ToastTabError)
          }
        }else if(this.AssureFields.age == 'Adulte_homme' || this.AssureFields.age == 'Adulte_femme'){
          if(this.ageAssure > 21 && this.ageAssure < 60){
            this.ListAssure.push(Assure);
            this.getHommeAssure()
            this.nbAssureAdded = this.nbAssureAdded + 1;

            if (this.nombreAssures > 0) {
              if (this.nbAssureAdded < this.nombreAssures) {
                this.$toasted.show('Ajouté avec succes! ', this.ToastTabSucess)
                this.ClearFormAssure();
                this.disableDateAssure =  false
              }
              if (this.nbAssureAdded == this.nombreAssures) {
                this.e1 = 6
              }
            }else {
              this.voidField = true
            }
          }else {
            this.$toasted.show('Date de naissance choisie ne correspond pas à un adulte !', this.ToastTabError)
          }
        }else if(this.AssureFields.age == 'homme' || this.AssureFields.age == 'femme'){
          if(this.ageAssure > 60 && this.ageAssure < 75){
            this.ListAssure.push(Assure);
            this.getHommeAssure()
            this.nbAssureAdded = this.nbAssureAdded + 1;

            if (this.nombreAssures > 0) {
              if (this.nbAssureAdded < this.nombreAssures) {
                this.$toasted.show('Ajouté avec succes! ', this.ToastTabSucess)
                this.ClearFormAssure();
                this.disableDateAssure =  false
              }
              if (this.nbAssureAdded == this.nombreAssures) {
                this.e1 = 6
              }
            }else {
              this.voidField = true
            }
          } else {
            this.$toasted.show('Date de naissance choisie ne correspond pas à un sénior !', this.ToastTabError)
          }
        }


      }else {
        this.$toasted.show('Tous les champs sont obligatoires sauf CNI !', this.ToastTabError)
      }

    },

    /*==========Fonction de nettoyage du formulaire apres recuperation des datas========*/
    ClearFormAssure: function () {
      if(this.checkbox == true){
        this.disabled_checkbox = true
      }else if(this.checkbox == false){
        this.disabled_checkbox = true
      }
      this.AssureFields.Nom = null,
          this.AssureFields.Prenom = null ,
          this.AssureFields.dateNaissance= null,
          this.AssureFields.CNI = null
      this.AssureFields.age = null

    },

    toggleCheckbox() {
      if(this.checkbox == true){
        this.AssureFields.Nom = this.ContractantFields.Nom
        this.AssureFields.Prenom = this.ContractantFields.Prenom
        this.AssureFields.dateNaissance = this.ContractantFields.dateNaissance
        this.dateNaiss = this.ContractantFields.dateNaissance
        this.disableDateAssure = true
        this.yearsDiffAssure()
      }else if(this.checkbox == false){
        this.disableDateAssure = false
        this.ClearForm()
      }
    },

    ClearForm: function () {
      this.AssureFields.Nom = null
      this.AssureFields.Prenom = null
      this.AssureFields.dateNaissance = null
      this.AssureFields.LieuNaissance = null
      this.AssureFields.age = null
    },

    DevisNextStep(){
      if (!store.state.isUserLoggedIn) {
        this.showLoginForm = true
      } else if(store.state.isUserLoggedIn){
        this.isContractant = true
        this.ContractantFields.Nom = this.$store.state.user.nom
        this.ContractantFields.Prenom = this.$store.state.user.prenom
        this.ContractantFields.Telephone = this.$store.state.user.telephone_port
        this.ContractantFields.Email = this.$store.state.user.email
        this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
        this.ContractantFields.Genre = this.$store.state.user.sexe
        this.ContractantFields.Situation = this.$store.state.user.statut_marital
        this.ContractantFields.dateNaissance = this.dateNaiss

        this.next()
        document.getElementById("testup").classList.add('widthThirt');

        this.calculTaxe()
        //this.calculTTC()
        
      }
      this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
    },

    ContractControl() {
      this.errors = {}
      if(this.ContractantFields.Genre != null && this.ContractantFields.Situation != null){
        if (this.ContractantFields.Nom && this.ContractantFields.Prenom) {
          if(this.ContractantFields.dateNaissance && this.ContractantFields.LieuNaissance){
            if(this.ContractantFields.Telephone && this.ContractantFields.Email){
              const validPhone = validatePhone(this.ContractantFields.Telephone);
              this.errors.phone = validPhone.error;

              const validEmail = validateEmail(this.ContractantFields.Email);
              this.errors.email = validEmail.error;
              if(validEmail.valide == true && validPhone.valide == true){

                this.next()
                document.getElementById("secondStep").classList.add('checked');
                document.getElementById("testup").classList.add('widthFour');
                //this.nextStep();




              }
            }else {
              this.$toasted.show('Téléphone et Email obligatoires! ', this.ToastTabError)
              this.animation = 'animate-wrong';
              setTimeout(() => {
                this.animation = '';
              }, 400);
            }

          }else {
            this.$toasted.show('Date et Lieu de naissance obligatoires! ', this.ToastTabError)
          }
        } else {
          this.$toasted.show('Nom et Prénom obligatoires! ', this.ToastTabError)
        }
      }else {
        this.$toasted.show('Genre et Situation obligatoires! ', this.ToastTabError)
      }

    },

    nextStep2() {
      this.animation = 'animate-out';
      setTimeout(() => {
        this.animation = 'animate-in';
        this.isContractant = false,
            this.isAssure = false,
            this.next()
            document.getElementById("secondStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
      }, 600);
    },

    AssureControl() {
      this.errors = {}
      if (this.AssureFields.Nom && this.AssureFields.Prenom && this.AssureFields.dateNaissance &&
          this.AssureFields.age) {
        this.nextStep2();
      }else {
        this.$toasted.show('tous les champs sont obligatoires! ', this.ToastTabError)
      }
    },

    yearsDiffContractant() {
      const date1 = dayjs(this.ContractantFields.dateNaissance);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');
      this.age = daydiff;

      if (this.age <0) {
        this.age = null;
        this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
        this.ContractantFields.dateNaissance = null

      } else if (this.age) {
        let year = Math.floor(this.age / 360);
        this.age = year;
        if(this.age < 18 || this.age <= 0){
          this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
          this.ContractantFields.dateNaissance = null
        }
      }
      else if (this.age<=0) {
        let year = Math.floor(this.age / 360);
        this.age = year;
        if(this.age < 18 || this.age <= 0){
          this.$toasted.show("Erreur, l'age doit pas etre supperieur à 18 ans! ", this.ToastTabError)
          this.ContractantFields.dateNaissance = null
        }
      }
    },

    nextStep() {
      this.animation = 'animate-out';
      setTimeout(() => {
        this.animation = 'animate-in';
        this.activeStep += 1;
        this.isContractant = false,
            this.isAssure = true
      }, 600);
    },

    BackToStep1(){
      this.animation = 'animate-out-back';
      setTimeout(() => {
        this.animation = 'animate-in-back';
        this.e1 = 4;
        this.activeStep -= 1;
        this.isContractant = true,
            this.isAssure = false
      }, 500);
    },
    uncheckMaternite (){
      if(this.fraisOptique == false && this.fraisDentaire == false){
        this.maternite = false
      }
    },

    addOptionMaternite(){
      if(this.pack == 'essentiel'){
        if(this.maternite){
          this.options.push(this.optionMaternite)
          this.totalHorsTaxe = (this.optionMaternite.prix * this.nbreAdulteFemme) + this.prixNetTotal
        }else{
          this.totalHorsTaxe = this.prixNetTotal - this.optionMaternite.prix * this.nbreAdulteFemme
        }
      }else if(this.pack == 'confort'){
        if(this.maternite){
          this.options.push(this.optionMaternite)
          this.optionMaternite.prix = 150000
          this.totalHorsTaxe = (this.optionMaternite.prix * this.nbreAdulteFemme) + this.prixNetTotal
        }else {
          this.totalHorsTaxe = this.prixNetTotal - this.optionMaternite.prix * this.nbreAdulteFemme
        }

      }

      this.getPrixOption()
      this.calculPrimeHorsTaxe()
    },

    addOptionOptique(){

      if(this.pack == 'serenite'){
        if(this.fraisOptique || this.fraisDentaire){
          if(this.nbreAdulteFemme > 0 && this.nbreAdulteHomme > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme > 0 && this.nbreEnfantGarcon > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme > 0 && this.nbreEnfantFille > 0){
            this.isMaternite = true
          }
          else {
            this.isMaternite = false

          }
          let Totale = this.adulteTotal + this.enfantTotal + this.seniorTotal
          this.totalHorsTaxe = this.prixNetTotal + this.optionOptique.prix * Totale
        } else{
          this.uncheckMaternite()
          this.isMaternite = false
          let Totale = this.adulteTotal + this.enfantTotal + this.seniorTotal
          this.totalHorsTaxe = this.prixNetTotal - this.optionOptique.prix * Totale
        }


      }
      this.getPrixOption()
      this.calculPrimeHorsTaxe()

    },

    addOptionDentaire(){

      if(this.pack == 'serenite'){
        if(this.fraisDentaire || this.fraisOptique){
          let Totale = this.adulteTotal + this.enfantTotal + this.seniorTotal
          this.totalHorsTaxe = this.prixNetTotal + this.optionDentaire.prix * Totale
          if(this.nbreAdulteFemme > 0 && this.nbreAdulteHomme > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme > 0 && this.nbreEnfantGarcon > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme > 0 && this.nbreEnfantFille > 0){
            this.isMaternite = true
          } else {
            this.isMaternite = false
          }
        } else{
          this.uncheckMaternite()
          this.isMaternite = false
          let Totale = this.adulteTotal + this.enfantTotal + this.seniorTotal
          this.totalHorsTaxe = this.prixNetTotal - this.optionDentaire.prix * Totale
        }
      }


      this.getPrixOption()
      this.calculPrimeHorsTaxe()
    },

    /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
    onlyNumber($event) {
      let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
      if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
        $event.preventDefault();
      }
    },

    /*====REMPLISAAGE DES PASSAGERS POUR DEVIS VOYAGE====*/
    CreateListPassager: function () {
      let Unpassager = {};

      if (this.age) {
        if (this.age < 18) {
          Unpassager.adulte_enfant = 'Enfant'
        } else if (this.age >= 18) {
          Unpassager.adulte_enfant = 'Adulte'
        }
        Unpassager.age_assure = this.age;
        Unpassager.dateNaissance = this.dateNaissance
        this.listAssure.push(Unpassager);
        this.age = null;

        if (this.listAssure.length === parseInt(this.nbassure)) {
          //this.PassedToNext()
          this.e1 = 3
          this.dialog1 = false
        } else {
          this.age = null;
          this.adulte_enfant = null
        }
      } else {
        this.$toasted.show("l'âge peut pas étre 0!", this.ToastTabError)
      }

    },

    /*Passenger Age calculation based on passenger birthday*/
    PassengerAgeCalculation() {
      let TodayDate = new Date()
      this.age = dayjs(TodayDate).diff(this.dateNaissance, 'year')

      let PassengerObject = {
        dateNaissance: this.dateNaissance,
        age: this.age
      }

      localStorage.setItem('passenger-birthady-age', JSON.stringify(PassengerObject))
    },

    PassengerAgeChange() {
      let Unpassager = {};
      if (this.listAssure.length === parseInt(this.nbassure)) {

        if (this.age < 18) {
          Unpassager.adulte_enfant = 'Enfant'
        } else if (this.age >= 18) {
          Unpassager.adulte_enfant = 'Adulte'
        }

        if (this.age != Unpassager.age_assure) {
          Unpassager.age_assure = this.age
          Unpassager.dateNaissance = this.dateNaissance
          this.listAssure.pop(Unpassager)
          this.listAssure.push(Unpassager)
          this.age = this.age
          //this.PassedToNext()
          this.e1 = 5
        }
      }
    },

    choix(){
      this.pack = 'essentiel'
      this.next()
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthFirst');
      this.dialog1 =  false
      this.options = []
      this.prixNetforAdulte = 0
      this.prixNetforEnfant = 0
      this.prixNetforSenior = 0
      this.nbreAdulteHomme = 0
      this.nbreAdulteFemme = 0

      this.adulteTotal = 0
      this.enfantTotal = 0
      this.seniorTotal = 0

      this.prixNetTotal = 0

      this.nbreEnfantGarcon = 0
      this.nbreEnfantFille = 0
      this.total = 0
      this.isSenior = false

      this.isBasic = true
      this.isEssentiel = false
      this.isConfort = false
      this.AllAssure = 0
    }, //Choix pour le pack Basic

    choix2(){
      this.pack = 'serenite'

      this.next()
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthFirst');

      this.prixNetforAdulte = 0
      this.prixNetforEnfant = 0
      this.prixNetforSenior = 0
      this.nbreAdulteHomme = 0
      this.nbreAdulteFemme = 0
      this.nbreEnfantGarcon = 0
      this.nbreEnfantFille = 0

      this.adulteTotal = 0
      this.enfantTotal = 0
      this.seniorTotal = 0
      this.total = 0
      this.prixNetTotal = 0

      this.isSenior = false

      this.isBasic = false
      this.isEssentiel = true
      this.isConfort = false
      this.AllAssure = 0
    }, //Choix pour le pack Essentiel

    choix3(){
      this.pack = 'confort'

      this.next()
      document.getElementById("firstStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthFirst');
      this.prixNetforAdulte = 0
      this.prixNetforEnfant = 0
      this.prixNetforSenior = 0
      this.nbreAdulteHomme = 0
      this.nbreAdulteFemme = 0

      this.adulteTotal = 0
      this.enfantTotal = 0
      this.seniorTotal = 0
      this.prixNetTotal = 0

      this.nbreEnfantGarcon = 0
      this.nbreEnfantFille = 0
      this.total = 0

      this.isSenior = false

      this.isBasic = false
      this.isEssentiel = false
      this.isConfort = true
      this.AllAssure = 0
    }, //Choix pour le pack Confort

    /* --------- Fonctions qui gerent la decrementation et l'incrementation du nombre d'adultes hommes  ----------- */
    incrementAdulteHomme () {
      let Assure
      Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal + 1
      this.AllAssure =  Assure

      this.nbreAdulteHomme++
      this.CalculAllAdulte()
      this.ShowOrNotSenior()

      if(this.pack == 'serenite'){
        if(this.nbreAdulteFemme > 0 && this.nbreAdulteHomme > 0){
          this.isMaternite = false
        }else if(this.nbreAdulteFemme <= 0 || this.nbreAdulteHomme <= 0){
          this.isMaternite = false
        }
      }else if(this.pack == 'confort'){
        if(this.nbreAdulteFemme > 0){
          this.isMaternite = true
        }else if(this.nbreAdulteFemme <= 0 || this.nbreAdulteHomme <= 0){
          this.isMaternite = false
        }
      } else {
        this.maternite = null
        this.isMaternite = false
      }
    },

    decrementAdulteHomme () {
      if(this.nbreAdulteHomme === 0 || this.nbreAdulteHomme === null) {
        this.$toasted.show("Nombre d'homme ne peut pas étre négatif !", this.ToastTabError)
        this.nbreAdulteHomme = 0
        if(this.nbreAdulteHomme == null && this.nbreAdulteFemme == null){
          this.adulteTotal = null
        }

      } else {
        let Assure
        Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal - 1
        this.AllAssure =  Assure

        this.nbreAdulteHomme--
        this.CalculAllAdulte()
        this.ShowOrNotSenior()

        if(this.pack == 'serenite'){
          if(this.nbreAdulteFemme > 0 && this.nbreAdulteHomme > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme <= 0 || this.nbreAdulteHomme <= 0){
            this.isMaternite = false
          }
        }else if(this.pack == 'confort'){
          if(this.nbreAdulteFemme > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme <= 0 || this.nbreAdulteHomme <= 0){
            this.isMaternite = false
          }
        }else {
          this.maternite = null
          this.isMaternite = false
        }
      }
    },

    /* --------- Fonctions qui gerent la decrementation et l'incrementation du nombre d'adultes femmes  ----------- */
    incrementAdulteFemme () {
      let Assure
      Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal + 1
      this.AllAssure =  Assure
      this.nbreAdulteFemme++
      this.CalculAllAdulte()
      this.ShowOrNotSenior()
      //this.calculTaxe()
      //this.calculTTC()
      if(this.pack == 'serenite'){
        if(this.nbreAdulteFemme > 0 && this.nbreAdulteHomme > 0){
          this.isMaternite = false
        }else if(this.nbreAdulteFemme <= 0 || this.nbreAdulteHomme <= 0){
          this.isMaternite = false
        }
      }else if(this.pack == 'confort'){
        if(this.nbreAdulteFemme > 0){
          this.isMaternite = true
        }else if(this.nbreAdulteFemme <= 0 || this.nbreAdulteHomme <= 0){
          this.isMaternite = false
        }
      }else {
        this.maternite = null
        this.isMaternite = false

      }
    },

    decrementAdulteFemme () {
      if(this.nbreAdulteFemme === 0 || this.nbreAdulteFemme === null) {
        this.$toasted.show("Nombre de femme ne peut pas étre négatif !", this.ToastTabError)
        if(this.nbreAdulteHomme == null && this.nbreAdulteFemme == null){
          this.adulteTotal = null
        }
      } else {
        let Assure
        Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal - 1
        this.AllAssure =  Assure
        this.nbreAdulteFemme--
        this.CalculAllAdulte()
        this.ShowOrNotSenior()
        //this.calculTaxe()
        //this.calculTTC()
        if(this.pack == 'serenite' || this.pack == 'confort'){
          if(this.nbreAdulteFemme > 0 && this.nbreAdulteHomme > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme <= 0 || this.nbreAdulteHomme <= 0){
            this.isMaternite = false
          }
        }else {
          this.maternite = null
          this.isMaternite = false

        }

      }
    },

    /* --------- Fonctions qui gerent la decrementation et l'incrementation du nombre d'enfants garcons  ----------- */
    incrementEnfantGarcon () {
      let Assure
      Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal + 1
      this.AllAssure =  Assure
      this.nbreEnfantGarcon++
      this.CalculAllEnfant()
      this.ShowOrNotSenior()

      if(this.pack == 'serenite' || this.pack == 'confort'){
        if(this.nbreAdulteFemme > 0 && this.nbreEnfantGarcon > 0){
          this.isMaternite = true
        }else if(this.nbreAdulteFemme <= 0 || this.nbreEnfantGarcon <= 0){
          this.isMaternite = false
        }
      }else {
        this.maternite = null
        this.isMaternite = false

      }
    },

    decrementEnfantGarcon () {
      if(this.nbreEnfantGarcon === 0 || this.nbreEnfantGarcon === null) {
        this.$toasted.show("Nombre de garçon ne peut pas étre négatif !", this.ToastTabError)
        if(this.nbreEnfantGarcon == null && this.nbreEnfantFille == null){
          this.enfantTotal = null
        }
        this.nbreEnfantGarcon = 0
      } else {
        let Assure
        Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal - 1
        this.AllAssure =  Assure
        this.nbreEnfantGarcon--
        this.CalculAllEnfant()
        this.ShowOrNotSenior()

        if(this.pack == 'serenite' || this.pack == 'confort'){
          if(this.nbreAdulteFemme > 0 && this.nbreEnfantGarcon > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme <= 0 || this.nbreEnfantGarcon <= 0){
            this.isMaternite = false
          }
        }else {
          this.maternite = null
          this.isMaternite = false

        }
      }
    },

    /* --------- Fonctions qui gerent la decrementation et l'incrementation du nombre d'enfants filles  ----------- */
    incrementEnfantFille () {
      let Assure
      Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal + 1
      this.AllAssure =  Assure
      this.nbreEnfantFille++
      this.CalculAllEnfant()
      this.ShowOrNotSenior()

      if(this.pack == 'serenite' || this.pack == 'confort'){
        if(this.nbreAdulteFemme > 0 && this.nbreEnfantFille > 0){
          this.isMaternite = true
        }else if(this.nbreAdulteFemme <= 0 || this.nbreEnfantFille <= 0){
          this.isMaternite = false
        }
      }else {
        this.maternite = null
        this.isMaternite = false
      }
    },

    decrementEnfantFille () {
      if(this.nbreEnfantFille === 0 || this.nbreEnfantFille === null) {
        this.$toasted.show("Nombre de fille ne peut pas étre négatif !", this.ToastTabError)
        if(this.nbreEnfantGarcon == null && this.nbreEnfantFille == null){
          this.enfantTotal = null
        }
      } else {
        let Assure
        Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal - 1
        this.AllAssure =  Assure
        this.nbreEnfantFille--
        this.CalculAllEnfant()
        this.ShowOrNotSenior()

        if(this.pack == 'serenite' || this.pack == 'confort'){
          if(this.nbreAdulteFemme > 0 && this.nbreEnfantFille > 0){
            this.isMaternite = true
          }else if(this.nbreAdulteFemme <= 0 || this.nbreEnfantFille <= 0){
            this.isMaternite = false
          }
        }else {
          this.maternite = null
          this.isMaternite = false

        }
      }
    },

    /* --------- Fonctions qui gerent la decrementation et l'incrementation du nombre de senior hommes  ----------- */
    incrementSeniorHomme () {
      let Assure
      Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal + 1
      this.AllAssure =  Assure
      this.nbreSeniorHomme++
      if(this.nbreSeniorHomme <= 2){
        this.CalculAllSenior()
      }else if(this.nbreSeniorHomme >2){
        this.nbreSeniorHomme = 2
        this.AllAssure =  Assure -1
        this.CalculAllSenior()
        this.$toasted.show("impossible de choisir plus de 2 hommes séniors !", this.ToastTabError)
      }
    },

    decrementSeniorHomme () {
      if(this.nbreSeniorHomme === 0 || this.nbreSeniorHomme === null) {
        this.$toasted.show("Nombre de Sénior homme ne peut pas étre négatif !", this.ToastTabError)
        this.nbreSeniorHomme = 0
        if(this.nbreSeniorHomme == null && this.nbreSeniorFemme == null){
          this.seniorTotal = null
        }
      } else {
        let Assure
        Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal - 1
        this.AllAssure =  Assure
        this.nbreSeniorHomme--
        this.CalculAllSenior()
      }
    },

    /* --------- Fonctions qui gerent la decrementation et l'incrementation du nombre de senior femmes  ----------- */
    incrementSeniorFemme () {
      let Assure
      Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal + 1
      this.AllAssure =  Assure
      this.nbreSeniorFemme++
      if(this.nbreSeniorFemme <= 2){
        this.CalculAllSenior()
      }else if(this.nbreSeniorFemme >2){
        this.nbreSeniorFemme = 2
        this.AllAssure =  Assure -1
        this.CalculAllSenior()
        this.$toasted.show("impossible de choisir plus de 2 femmes séniors !", this.ToastTabError)
      }
    },

    decrementSeniorFemme () {
      if(this.nbreSeniorFemme === 0 || this.nbreSeniorFemme === null) {
        this.$toasted.show("Nombre de Sénior femme ne peut pas étre négatif !", this.ToastTabError)
        this.nbreSeniorFemme = 0
        if(this.nbreSeniorHomme == null && this.nbreSeniorFemme == null){
          this.seniorTotal = null
        }
      } else {
        let Assure
        Assure = this.adulteTotal + this.enfantTotal + this.seniorTotal - 1
        this.AllAssure =  Assure
        this.nbreSeniorFemme--
        this.CalculAllSenior()
      }
    },
    showNotification(){
      if(this.AllAssure > 0) {
        this.bottomPushNotif = true
      }else {
        this.bottomPushNotif = false
      }
    },

    /* --------- Fonctions qui totalise le nombre d'adultes  ----------- */
    CalculAllAdulte(){
      let Adulte
      Adulte = this.nbreAdulteHomme + this.nbreAdulteFemme
      this.total =  Adulte
      if(this.pack == 'essentiel'){
        this.prixNetforAdulte = this.packBasic.prix  * this.total
      }else if(this.pack == 'serenite'){
        this.prixNetforAdulte = this.packEssentiel.prix * this.total
      }else if(this.pack == 'confort'){
        this.packConfort.prix = 370000
        this.prixNetforAdulte = this.packConfort.prix * this.total
      }

      this.adulteTotal = this.total
      this.ToPay()
      this.showNotification()
    },

    /* --------- Fonctions qui totalise le nombre d'enfants  ----------- */
    CalculAllEnfant() {
      let Enfant
      Enfant = this.nbreEnfantFille + this.nbreEnfantGarcon
      this.total = Enfant
      this.enfantTotal = this.total
      /* --------- POUR LE PACK BASIC ENFANTS  ----------- */
      if (this.pack == 'essentiel') {
        this.prixNetforEnfant = this.packBasic.prix * this.total
        /* --------- POUR LE PACK ESSENTIEL ENFANTS  ----------- */
      } else if (this.pack == 'serenite') {
        this.prixNetforEnfant = this.packEssentiel.prix * this.total
        /* --------- POUR LE PACK CONFORT ENFANTS  ----------- */
      }else if(this.pack == 'confort'){
        this.packConfort.prix = 270000
        this.prixNetforEnfant = this.packConfort.prix * this.total
      }
      this.ToPay()
      this.showNotification()
    },

    /* --------- Fonctions qui totalise le nombre de seniors  ----------- */
    CalculAllSenior(){
      const firstMajor = 290000;
      const secondMajor = 217500;
      const thirstMajor = 145000


      let Senior
      Senior = this.nbreSeniorFemme + this.nbreSeniorHomme
      this.total =  Senior
      this.seniorTotal = this.total
      /* --------- POUR LE PACK ESSENTIEL SENIOR  ----------- */
      if (this.pack == 'serenite') {
        if (this.seniorTotal == 1) {
          this.packEssentiel.prix = 290000 + firstMajor
          this.prixNetforSenior = this.packEssentiel.prix
        } else if (this.seniorTotal == 2) {
          this.packEssentiel.prix = 290000 + secondMajor
          this.prixNetforSenior = this.packEssentiel.prix + 580000

        }else if(this.seniorTotal == 3){
          this.packEssentiel.prix = 290000 + thirstMajor
          this.prixNetforSenior = this.packEssentiel.prix + 1087500
        }else if(this.seniorTotal == 4){
          this.packEssentiel.prix = 290000 + thirstMajor
          this.prixNetforSenior = this.packEssentiel.prix + 1522500
        }else if(this.seniorTotal == 0){
          this.packEssentiel.prix = 0
          this.prixNetforSenior = this.packEssentiel.prix * this.total
        }
      }
      this.ToPay()
      this.showNotification()
    },

    ToPay(){
      if(this.pack != 'serenite'){
        this.prixNetTotal = (this.prixNetforAdulte + this.prixNetforEnfant)
        this.calculTaxe()
        this.calculTTC()
      }else {
        if(this.isSenior == false){
          this.prixNetTotal = (this.prixNetforAdulte + this.prixNetforEnfant)
          this.calculTaxe()
        this.calculTTC()
        }else if(this.isSenior == true){
          this.prixNetTotal = (this.prixNetforSenior + this.prixNetforAdulte + this.prixNetforEnfant)
          this.calculTaxe()
          this.calculTTC()
        }else {
          this.prixNetTotal = (this.prixNetforAdulte + this.prixNetforEnfant)
          this.calculTaxe()
          this.calculTTC()
        }
      }

    },

    /* --------- Fonctions qui affiche la partie senior si adulte = 2 et enfant = 2, ce qui fait 4  ----------- */
    ShowOrNotSenior(){
      if(this.pack == 'serenite'){
        if(this.enfantTotal >= 2 && this.adulteTotal >= 2){
          this.isSenior =  true
        }else {
          this.AllAssure = this.adulteTotal + this.enfantTotal
          this.seniorTotal = 0
          this.nbreSeniorHomme = 0
          this.nbreSeniorFemme = 0
          this.isSenior = false
          this.prixNetforSenior = null
        }
      }

    },

    BackToStepAssure(){
      this.animation = 'animate-out-back';
      setTimeout(() => {
        this.animation = 'animate-in-back';
        this.e1 = 5;
        this.activeStep -= 1;
        this.isContractant = false,
            this.isAssure = true
      }, 500);
    },

    BackToStepOption(){
      if(this.pack == 'essentiel'){
        this.animation = 'animate-out-back';
        setTimeout(() => {
          this.animation = 'animate-in-back';
          this.e1 = 2;
          //this.activeStep -= 1;
        }, 500);
      }else if(this.pack == 'confort'){
        if(this.nbreAdulteFemme <= 0){
          this.animation = 'animate-out-back';
          setTimeout(() => {
            this.animation = 'animate-in-back';
            this.e1 = 2;
            //this.activeStep -= 1;
          }, 500);
        }else if(this.nbreAdulteFemme > 0){
          this.animation = 'animate-out-back';
          setTimeout(() => {
            this.animation = 'animate-in-back';
            this.e1 = 3;
            //this.activeStep -= 1;
          }, 500);
        }
      }
      else {
        this.animation = 'animate-out-back';
        setTimeout(() => {
          this.animation = 'animate-in-back';
          this.e1 = 3;
          //this.activeStep -= 1;
        }, 500);
      }
    },

    /* --------- Fonctions qui affiche les donnees pour la partie recap  ----------- */
    nextStepToOption(){
      if(this.adulteTotal || this.enfantTotal){
        //this.basic_pack_price = this.prixNetTotal
        if (this.pack == 'essentiel') {
          if (!store.state.isUserLoggedIn) {
            this.showLoginForm = true
          } else if(store.state.isUserLoggedIn){
            if(this.AllAssure >= 10){
              this.isContractant = true
              this.step = 3
              document.getElementById("testup").classList.add('widthThirt');
              this.ContractantFields.Nom = this.$store.state.user.nom
              this.ContractantFields.Prenom = this.$store.state.user.prenom
              this.ContractantFields.Telephone = this.$store.state.user.telephone_port
              this.ContractantFields.Email = this.$store.state.user.email
              this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
              this.ContractantFields.Genre = this.$store.state.user.sexe
              this.ContractantFields.Situation = this.$store.state.user.statut_marital
              this.ContractantFields.dateNaissance = this.dateNaiss
              this.AssureFields.dateNaissance = this.dateNaiss
              this.calculTaxe()
              this.calculTTC()
            }else{
              this.$toasted.show(this.$t('error.devis.devis_sante.assur_care.min_10_person_obligatoire'), this.ToastTabError)
            }
          }
          this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance

        }else if(this.pack == 'serenite'){
          if (!store.state.isUserLoggedIn) {
            this.showLoginForm = true
          } else if(store.state.isUserLoggedIn){
            if(this.zone != null){
              this.isContractant = true
              this.step = 3
              document.getElementById("testup").classList.add('widthThirt');
              this.ContractantFields.Nom = this.$store.state.user.nom
              this.ContractantFields.Prenom = this.$store.state.user.prenom
              this.ContractantFields.Telephone = this.$store.state.user.telephone_port
              this.ContractantFields.Email = this.$store.state.user.email
              this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
              this.ContractantFields.Genre = this.$store.state.user.sexe
              this.ContractantFields.Situation = this.$store.state.user.statut_marital
              this.ContractantFields.dateNaissance = this.dateNaiss
              this.AssureFields.dateNaissance = this.dateNaiss
              // this.calculTaxe()
              // this.calculTTC()
              }else {
                this.$toasted.show("Choix zone obligatoire!", this.ToastTabError)
              }
          }
          this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
        } else if(this.pack == 'confort'){
            if (!store.state.isUserLoggedIn) {
              this.showLoginForm = true
            } else if(store.state.isUserLoggedIn){
              if(this.zone != null){
                this.isContractant = true
              this.step = 3
              document.getElementById("testup").classList.add('widthThirt');
              this.ContractantFields.Nom = this.$store.state.user.nom
              this.ContractantFields.Prenom = this.$store.state.user.prenom
              this.ContractantFields.Telephone = this.$store.state.user.telephone_port
              this.ContractantFields.Email = this.$store.state.user.email
              this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance
              this.ContractantFields.Genre = this.$store.state.user.sexe
              this.ContractantFields.Situation = this.$store.state.user.statut_marital
              this.ContractantFields.dateNaissance = this.dateNaiss
              this.AssureFields.dateNaissance = this.dateNaiss
              // this.calculTaxe()
              // this.calculTTC()
              }else{
                this.$toasted.show("Choix zone obligatoire!", this.ToastTabError)
              }
            }
            this.ContractantFields.dateNaissance = this.$store.state.user.datenaissance

         
        }
        else {
          this.next()
          document.getElementById("testup").classList.add('widthSecond');

        }

      }else {
        this.$toasted.show("Adultes ou enfants obligatoires!", this.ToastTabError)
      }
      this.nombreAssures = this.AllAssure

    },

    // fonction pour formattage de Date (:-)
    DateFormater: function (TheDate) {
      if (TheDate) {
        return dayjs(TheDate).format("DD-MM-YYYY");
      }
    },

    siOui() {
      this.optionCardio = true;
      this.dialog1 = false
    },

    success() {
      if (this.age == true) {
        this.optionCardio == true
      } else {
        this.optionCardio == false
      }
    },

    Checking(val) {

      if (val.nompack === 'Pack Prévention (Check-up Annuel)') {
        this.optionPrevention = true
      } else {
        this.optionPrevention = false
      }


    },


    setListassure_tostore(item){
      let listAssure = []
      for(let i of item){
        listAssure.push({
          nom: i.Nom,
          prenom: i.Prenom,
          datenaissance:i.DateNaissance,
          numero_cni: i.CNI,
          genre: i.Age,
          questionnaire_medical:MedicalQuestion.questions
        })
      }
      return listAssure
    },

    /*===Send of data to API allowing create proposition for the customer===*/
    CreateDevis: function() {
      if (!store.state.isUserLoggedIn) {
        this.showLoginForm = true
      } else {

        if(this.assureurs.length > 0){
          if(this.dateEffet && this.dateEffet!=null && this.dateEcheance && this.dateEcheance!=null ) {
          let packName = ''
          let zone = ''
          if(this.pack == 'essentiel'){
            packName = 'Essentiel 70%'
            zone = 'Senegal'
            this.zone = zone
          }else if(this.pack == 'serenite'){
            packName = 'Serenite 80%'
          }else if(this.pack == 'confort'){
            packName = 'Confort 90%'
          }

          const ASSURCARE = {
            details : this.setListassure_tostore(this.ListAssure),
            userid:store.state.user._id,
            createur:store.state.user._id,
            Pack: packName,
            Assure : {
              Adulte : {
                Homme : this.nbreAdulteHomme,
                Femme : this.nbreAdulteFemme
              },
              Enfant : {
                Garcon : this.nbreEnfantGarcon,
                Fille : this.nbreEnfantFille,
              },
              Senior : {
                Homme : this.nbreSeniorHomme,
                Femme : this.nbreSeniorFemme
              },
              nombre_assures:  this.nbreAdulteHomme + this.nbreAdulteFemme + this.nbreEnfantGarcon + this.nbreEnfantFille + this.nbreSeniorHomme + this.nbreSeniorFemme
            },
            dateSouscription: dayjs(new Date()).format('YYYY-MM-DD'),
            ListAssure:this.ListAssure,
            dateEffet: this.dateEffet,
            dateEcheance: this.dateEcheance,
            MontantNet: this.prixNetTotal,
            branche: "Santé",
            prime_ttc :this.ttc,
            plateforme:"Front",
            taxe:this.taxe,
            accessoire : this.frais,
            zone : this.zone,
            assureurs: this.assureurs
          };

          
          this.disabledButtonValidate = true
          this.dialogLoading = true;

          Api().post('assurcare/add', ASSURCARE)
              .then((result) => {
                      this.$store.dispatch('setDevis', result.data);
                      this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push({name : 'listDevis'})
              }).catch((err) => {
            console.log(err)
          });
          document.getElementById("thirstStep").classList.add('checked');
          document.getElementById("testup").classList.add('widthSix');
        }else{
          this.$toasted.show("Date d'effet et date d'échéance obligatoires !", this.ToastTabError)
        }
          
        }else {
          this.$toasted.show('Choisissez au moins un assureur !', this.ToastTabError)
        }
      }
    },

    yearsDiffDateEffet() {
      const date1 = dayjs(this.dateEffet);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');

      this.ageArrivee = daydiff;

      if (this.ageArrivee > 0) {
        this.ageArrivee = null;
        this.annee_mois = '';
        this.$toasted.show('Erreur, date postérieure à la date actuelle! ', this.ToastTabError)
        this.dateEffet = null

      }

    },
    passFirstStep(){
      document.getElementById("sixStep").classList.add('checked');
      document.getElementById("testup").classList.add('widthSix');
    },

    BacktoFirstStep(){
      for(let p of this.zoneList){
        p.prix = 0
      }
      this.zone = null;
      this.step = 1
      document.getElementById("firstStep").classList.remove('checked');
      document.getElementById("testup").classList.remove('widthThirt');

    },

    BacktoSecondStep(){
      this.step = 2
      document.getElementById("testup").classList.remove('widthFive');

    },

    BacktoThirstStep(){
        this.step = 3
        document.getElementById("testup").classList.remove('widthFour');
        document.getElementById("secondStep").classList.remove('checked');
    },
    BacktoFiveStep(){
      this.step = 3
      document.getElementById("secondStep").classList.remove('checked');

    },

    prev() {
      this.step--;
    },
    next() {
      this.step++;
    },

    /*============= fonction du switch pour l'affichage du champ beneficiaire ===========*/
    switchBenef() {
      if (!this.$store.state.isUserLoggedIn) {
        this.showLoginForm = true
      } else if (this.switch1) {
        if (!this.$store.state.isUserLoggedIn) {
          this.showLoginForm = true;
          this.switch1 = false;
          this.proprietaire = ''
        } else {
          this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
        }
      } else {
        this.proprietaire = '';
        this.dialogInfoBeneficiaire = true
      }
    },

    /*============= Action sur le button annuler du popup beneficiaire ===========*/
    annulerBenef() {
      this.dialogInfoBeneficiaire = false;
      this.switch1 = true;
      this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
    },

    /*============= Fonction pour calculer la date 1ere mise en circulation ===========*/
    yearsDiff() {
      const date1 = dayjs(this.dateCircule);
      const date2 = dayjs(new Date().toISOString().substr(0, 10));
      let daydiff = date2.diff(date1, 'days');
      this.age = daydiff;

      if (this.age < 0) {
        this.age = null;
        this.annee_mois = '';
        this.$toasted.show('Erreur, date antérieure à la date actuelle! ', this.ToastTabError)
        this.dateCircule = null

      } else if (this.age >= 360) {
        let year = Math.floor(this.age / 360);
        this.age = year;
        this.annee = year;
        this.year = this.age;
        this.an = this.annee_mois = 'an(s)'
      }

    },

    infoFiscale() {
      this.forceFis = !this.forceFis;
      this.carteNouvelle = false;
      this.carteAncienne = false;
    },

    infoDate() {
      this.dateCircul = !this.dateCircul;
      this.dateNouvelle = false;
      this.dateAncienne = false;
    },

    Option: function () {
      this.isHidden = !this.isHidden;
    },

    zeroControl(){
      if(this.duree<=0){
        this.duree = null
      }
    },
    numberMonth() {
      this.zeroControl()
      if (this.duree <= 12) {
        return true
      }else {

        return false
      }
    },

    isMobile: function () {
      if (screen.width <= 760) {
        return true
      } else {
        return false
      }
    },

    isTablette() {
      if (screen.width > 425 && screen.width <= 768) {
        return true
      } else {
        return false
      }
    },

    isDesktop: function () {
      if (screen.width > 768) {
        return true
      } else {
        return false
      }
    },

  },

  computed: {
    progressClasses() {
      let result = 'progress '
      if (this.currentStep && this.currentStep.label === 'complete') {
        return result += 'progress--complete'
      }
      return result += `progress--${this.steps.indexOf(this.currentStep) + 1}`
    },

    formTitle() {
      return this.editedIndex === -1 ? 'Nouveau véhicule' : 'Modification du véhicule'
    },

    /*=================proprieté permettant de selectionner touts les assureurs à la fois ==============*/
    selectAll: {
      get: function () {
        return this.listeAssureurs ? this.selected.length == this.listeAssureurs.length : false;
      },
      set: function (value) {
        const assureurs = [];

        if (value) {
          this.listeAssureurs.forEach(function (assure) {
            assureurs.push(assure.societe);
          });
        }
        this.assureurs = assureurs;
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    model(val) {
      if (typeof val == 'object') {
        this.model = val.Type
      } else if (typeof val == 'string') {
        this.model = val
      }
    },

    showLoginForm(val) {
      if (val == false) {
        if (store.state.isUserLoggedIn) {
          this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
        }
      }
    }
  },

  mounted: function () {
    window.scrollTo(0, 0);
    this.getListePartenaire()
    this.checkToken()
    esk('track', 'Conversion');



    (function () {
      "use strict";
      const jQueryPlugin = (window.jQueryPlugin = function (ident, func) {
        return function (arg) {
          if (this.length > 1) {
            this.each(function () {
              const $this = $(this);

              if (!$this.data(ident)) {
                $this.data(ident, func($this, arg));
              }
            });

            return this;
          } else if (this.length === 1) {
            if (!this.data(ident)) {
              this.data(ident, func(this, arg));
            }

            return this.data(ident);
          }
        };
      });
    })();

    (function () {
      "use strict";
      function Guantity($root) {
        const element = $root;
        const quantity = $root.first("data-quantity");
        let quantity_target = $root.find("[data-quantity-target]");
        let quantity_minus = $root.find("[data-quantity-minus]");
        let quantity_plus = $root.find("[data-quantity-plus]");
        let quantity_ = quantity_target.val();
        $(quantity_minus).click(function () {
          quantity_target.val(--quantity_);
        });
        $(quantity_plus).click(function () {
          quantity_target.val(++quantity_);
        });
      }
      $.fn.Guantity = jQueryPlugin("Guantity", Guantity);
      $("[data-quantity]").Guantity();
    })();



    // eslint-disable-next-line no-undef
    $(document).ready(function(){
      $('button').click(function(e){
        let button_classes, value = +$('.counter').val();
        button_classes = $(e.currentTarget).prop('class');
        if(button_classes.indexOf('up_count') !== -1){
          value = (value) + 1;
        } else {
          value = (value) - 1;
        }
        value = value < 0 ? 0 : value;
        $('.counter').val(value);
      });
      $('.counter').click(function(){
        $(this).focus().select();
      });
    });

  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/button.css";
@import "../assets/css/devis_css.css";
@import "../assets/css/assurcare/form_assurcare.css";

.card_width {
  width:170px!important
}
.img_margin_top {
  margin-top : -57%!important;
}
.to-left {
  text-align: left;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 15px;
}
.form {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 15px!important;
}

.form .page {
  height: auto;
}

button.next {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
}

button.previous {
  position: absolute;
  bottom: 0;
  left: 0;
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}


button.edit {
  position: absolute;
  bottom: 0;
  right: 0;
}

h4 {
  color: #29323a;
  margin-bottom: 15px;
  font-weight: 600;
}

html {
  background-color: #1a1a1a;
  overflow: hidden;
}
.middle {
  width: auto;
  text-align: center;
  /* Made by */
}
.middle h1 {
  font-family: "Inter", sans-serif;
  color: #fff;
}
.middle input[type="radio"] {
  display: none;
}
.middle input[type="radio"]:checked + .box {
  background-color: rgba(255, 164, 9, 0.07);
  transition: all .33s ease;
  border: 2px solid #ffa409!important;
  color: #29323a;
}
.middle input[type="radio"]:checked + .box span {
  color: #29323a;
  transform: translateY(70px);
}
.middle input[type="radio"]:checked + .box span:before {
  transform: translateY(0px);
  opacity: 1;
}
.middle .box {
  width: 220px;
  height: 150px;
  border-radius: 12px;
  background-color: #fff;
  transition: all 250ms ease;
  will-change: transition;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  position: relative;
  box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
  font-size: 10px;
  border: 1px solid #d9dee3;
  font-family: Open Sans,sans-serif;
  font-weight: 900;
}
.middle .box:hover {
  background-color: rgba(255, 164, 9, 0.07);
  transition: all .33s ease;
  border: 2px solid #ffa409;
}
.middle .box:hover span {
  color: #29323a;
}

.middle .box:active {
  transform: translateY(10px);
}
.middle .box span {
  position: absolute;
  transform: translate(0, 60px);
  left: 0;
  right: 0;
  padding-top: 15%;
  transition: all 300ms ease;
  font-size: 1.5em;
  user-select: none;
  color: #29323a;
}
.middle .box span:before {
  font-size: 1.2em;
  font-family: FontAwesome;
  display: block;
  transform: translateY(-80px);
  opacity: 0;
  transition: all 300ms ease-in-out;
  font-weight: normal;
  color: #fff;
}
.middle p {
  color: #fff;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}
.middle p a {
  text-decoration: underline;
  font-weight: bold;
  color: #fff;
}
.middle p span:after {
  content: "\f0e7";
  font-family: FontAwesome;
  color: yellow;
}

.widthFirst{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:33.11112%;
}
.widthSecond{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:40%;
}
.widthThirt{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:48%;
}
.widthFour{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:66%;
}
.widthFive{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:65%;
}
.widthSix{
  background-color: var(--custom-color-primary)!important;
  height: 5px;
  border-radius: 5px;
  transition: width .33s ease;
  width:100%;
}

















.paralax-cover-image {
  background-image: url('../assets/img/assurance/sante.jpg');
  position: relative;
  background-size: contain!important;
  background-position: 50%;
  min-height: 230px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  /*padding: 20px;*/
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image {
  background-attachment: fixed;
  background-position: 50% 50px;
}


.paralax-cover-image_mobile {
  background-image: url('../assets/img/assurance/sante_mobile.jpg');
  position: relative;
  background-size: contain;
  background-position: 50%;
  min-height: 150px;
  width: 100%;
  margin: 0 0 0;
  display: flex;
  //padding: 20px;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;

}
.paralax-cover-image_mobile p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
  color: #fff;
  font-size: 2em;
  line-height: 1.25;
  z-index: 1;
  margin-bottom: 0;
  max-width: 610px;
  text-align: center;
  margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.paralax-cover-image_mobile {
  // background-attachment: fixed;
  background-position: 100% 40px;
}


.hero {
  position: relative;
  background-size: cover;
  background-position: center center;
  height: 680px;
  min-height: 320px;
  max-height: 100%;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
  -ms-flex-pack: center;
  padding: 20px;
}
.hero .content_home {
  position: relative;
  min-height: 280px;
  width: 100%;
  margin-left: 8.5%;
  z-index: 2;
  /*//background: red;*/
}
.hero .content_home p {
  color: rgb(255, 255, 255);
  font-size: 20px;
  font-weight: 300;
  width: 100%;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}
























/*== start of code for tooltips ==*/
.tool {
  cursor: help;
  position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 100;
}


/*== pointer tip ==*/
.tool::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565C61 transparent transparent transparent;
  bottom: 100%;
  content: "";
  margin-left: -0.5em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26), opacity .65s .5s;
  transform:  scale(.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
}


/*== speech bubble ==*/
.tool::after {
  background: #565C61;
  border-radius: .25em;
  bottom: 176%;
  color: #EDEFF0;
  font-size:15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
  transform:  scale(.6) translateY(50%);
  width: 17.5em;

}

.tool:hover::after,
.tool:focus::after  {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26);
}

@media (max-width: 760px) {
  .tool::after {
    font-size: .75em;
    margin-left: -5em;
    width: 10em;
  }
}



.muted{
  font-size: 15px;
  margin-left: 2px;
}
.main {
  margin-left: 5px;
}
main_prix{
  margin-left: 10px;
  width: 100px;
}

.new_counter {
  width: 45px;
  border-radius: 0px !important;
  text-align: center;
}
.up_count {
  margin-bottom: 10px;
  margin-left: -4px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  color: #ffa409;
}
.down_count {
  margin-bottom: 10px;
  margin-right: -4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  color: #ffa409;
}


.souscrip_switch input[type="radio"] {
  display: none;
}
.souscrip_switch label {
  position: relative;
  display: inline-block;
  padding: 3px 3px 3px 20px;
  cursor: pointer;
  font-size: 15px;
}
.souscrip_switch label::before,
.souscrip_switch label::after {
  position: absolute;
  content: '';
  top: 50%;
  border-radius: 100%;
  -webkit-transition: all .2s;
  transition: all .2s;
}
.souscrip_switch label::before {
  left: 0;
  width: 14px;
  height: 14px;
  margin-top: -8px;
  background: #f3f3f3;
  border: 1px solid #ccc;
}
.souscrip_switch label:hover::before {
  background: #fff;
}
.souscrip_switch label::after {
  opacity: 0;
  left: 4px;
  width: 8px;
  height: 8px;
  margin-top: -4px;
  background: #ffa409;
  -webkit-transform: scale(2);
  transform: scale(2);
}
.souscrip_switch input[type="radio"]:checked + label::before {
  background: #fff;
  border: 1px solid #ffa409!important;
}
.souscrip_switch input[type="radio"]:checked + label::after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}







// .toggle {
//   position: relative;
//   width: 82px;
//   height: 35px;
//   border: 3px solid #f9f9f9;
//   border-radius: 40px;
// }

// .toggle input[type="checkbox"] {
//   opacity: 0;
//   cursor: pointer;
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 10;
//   width: 84px;
//   height: 34px;
// }

// .toggle .btn {
//   display: block;
//   position: absolute;
//   z-index: 4;
//   top: -3px;
//   left: -1px;
//   width: 37px;
//   height: 37px;
//   background: #F5F5F5;
//   border: 1px solid #e8e8e8;
//   border-radius: 100%;
//   box-shadow: 0 2px 4px rgba(100, 100, 100, 0.1);
//   transition: left .25s ease-in-out;
// }

// .toggle input[type="checkbox"]:checked ~ .btn {
//   left: 44px;
// }

// .toggle .texts {
//   position: absolute;
//   top: 9px;
//   z-index: 2;
//   width: 100%;
//   font-family: 'Lato', Helvetica, sans-serif;
//   font-weight: bold;
//   color: #fff;
//   text-transform: uppercase;
//   font-size: 14px;
// }

// .toggle .texts:before {
//   content: "Oui";
//   position: absolute;
//   left: 10px;
// }

// .toggle .texts:after {
//   content: "No";
//   position: absolute;
//   right: 8px;
// }

// .toggle .bg {
//   display: block;
//   background: #F56557;
//   position: absolute;
//   z-index: 0;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   border-radius: 40px;
//   box-shadow: inset 0 0px 2px 1px rgba(0, 0, 0, 0.3);
//   transition: background .25s ease-in;
// }

// .toggle input[type="checkbox"]:checked ~ .bg {
//   background: #48C893;
// }

.to-right {
  float: right!important;
}






/*== start of code for tooltips ==*/
.tool {
  cursor: help;
  position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
  left: 50%;
  opacity: 0;
  position: absolute;
  z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
  opacity: 1;
  transform: scale(1) translateY(0);
  z-index: 100;
}


/*== pointer tip ==*/
.tool::before {
  border-style: solid;
  border-width: 1em 0.75em 0 0.75em;
  border-color: #565C61 transparent transparent transparent;
  bottom: 100%;
  content: "";
  margin-left: -0.5em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26), opacity .65s .5s;
  transform:  scale(.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
}


/*== speech bubble ==*/
.tool::after {
  background: #565C61;
  border-radius: .25em;
  bottom: 176%;
  color: #EDEFF0;
  font-size:15px;
  content: attr(data-tip);
  margin-left: -8.75em;
  padding: 1em;
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26) .2s;
  transform:  scale(.6) translateY(50%);
  width: 17.5em;

}

.tool:hover::after,
.tool:focus::after  {
  transition: all .65s cubic-bezier(.84,-0.18,.31,1.26);
}

@media (max-width: 760px) {
  .tool::after {
    font-size: .75em;
    margin-left: -5em;
    width: 10em;
  }
}







.card {
  background-color: #fff;
  width: 240px;;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 2rem;
  box-shadow: 0px 1rem 1.5rem rgba(0,0,0,0.1)!important;
}
.card .banner {
  background: #FAFAFA;
  //height: 6rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
}
.card .banner .svg {
  background-color: #fff;
  //width: 8rem;
  //height: 8rem;
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1);
  border-radius: 50%;
  transform: translateY(50%);
  transition: transform 200ms cubic-bezier(0.18, 0.89, 0.32, 1.28);
  float: left;
}
.card:hover {
  transform: translateY(0.1%) scale(1);
}
.card .menu {
  width: 100%;
  height: 5.6rem;
  padding: 1rem;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  position: relative;
  box-sizing: border-box;
}
.card .menu .opener {
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  border-radius: 50%;
  transition: background-color 100ms ease-in-out;
}
.card .menu .opener:hover {
  background-color: #f2f2f2;
}
.card .menu .opener span {
  background-color: #404040;
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  top: 0;
  left: calc(50% - 0.2rem);
  border-radius: 50%;
}
.card .menu .opener span:nth-child(1) {
  top: 0.45rem;
}
.card .menu .opener span:nth-child(2) {
  top: 1.05rem;
}
.card .menu .opener span:nth-child(3) {
  top: 1.65rem;
}
.card h2.name {
  text-align: center;
  padding: 0 2rem 0.5rem;
  margin: 0;
  color: #ffa409;
}
.card .title {
  color: #a0a0a0;
  font-size: 0.85rem;
  text-align: center;
  padding: 0 2rem 1.2rem;
}
.card .actions {
  padding: 0 2rem 1.2rem;
  display: flex;
  flex-direction: column;
  order: 99;
}
.card .actions .follow-info {
  padding: 0 0 1rem;
  display: flex;
}
.card .actions .follow-info h2 {
  text-align: center;
  width: 40%;
  margin: 0;
  box-sizing: border-box;
}
.card .actions .follow-info h2 a {
  text-decoration: none;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  border-radius: 0.8rem;
  transition: background-color 100ms ease-in-out;
}
.card .actions .follow-info h2 a span {
  color: #1c9eff;
  font-weight: bold;
  transform-origin: bottom;
  transform: scaleY(1.3);
  transition: color 100ms ease-in-out;
}
.card .actions .follow-info h2 a small {
  color: #afafaf;
  font-size: 0.85rem;
  font-weight: normal;
}
.card .actions .follow-info h2 a:hover {
  background-color: #f2f2f2;
}
.card .actions .follow-info h2 a:hover span {
  color: #007ad6;
}






/*  Toggle Switch  */

.toggleSwitch span span {
  display: none;
}

  .toggleSwitch {
    display: inline-block;
    height: 18px;
    position: relative;
    overflow: visible;
    padding: 0;
    margin-left: 30px;
    cursor: pointer;
    width: 40px
  }
  .toggleSwitch * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .toggleSwitch label,
  .toggleSwitch > span {
    line-height: 20px;
    height: 20px;
    vertical-align: middle;
  }
  .toggleSwitch input:focus ~ a,
  .toggleSwitch input:focus + label {
    outline: none;
  }
  .toggleSwitch label {
    position: relative;
    z-index: 3;
    display: block;
    width: 100%;
  }
  .toggleSwitch input {
    position: absolute;
    opacity: 0;
    z-index: 5;
  }
  .toggleSwitch > span {
    position: absolute;
    left: -50px;
    width: 100%;
    margin: 0;
    padding-right: 50px;
    text-align: left;
    white-space: nowrap;
  }
  .toggleSwitch > span span {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    display: block;
    width: 50%;
    margin-left: 50px;
    text-align: left;
    font-size: 1em;
    width: 100%;
    left: 15%;
    top: -1px;
    opacity: 0;
  }
  .toggleSwitch a {
    position: absolute;
    right: 50%;
    z-index: 4;
    display: block;
    height: 100%;
    padding: 0;
    left: 2px;
    width: 18px;
    background-color: #fff;
    border: 1px solid #CCC;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }
  .toggleSwitch > span span:first-of-type {
    color: #ccc;
    opacity: 1;
    left: 45%;
  }
  .toggleSwitch > span:before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 50px;
    top: -2px;
    background-color: #fafafa;
    border: 1px solid #ccc;
    border-radius: 30px;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
  }
  .toggleSwitch input:checked ~ a {
    border-color: #fff;
    left: 100%;
    margin-left: -8px;
  }
  .toggleSwitch input:checked ~ span:before {
    border-color: #ffa409;
    box-shadow: inset 0 0 0 30px #ffa409;
  }
  .toggleSwitch input:checked ~ span span:first-of-type {
    opacity: 0;
  }
  .toggleSwitch input:checked ~ span span:last-of-type {
    opacity: 1;
    color: #fff;
  }


 .pack {
	 display: flex;
	 flex-direction: column;
	 max-width: 12em!important;
   min-height: 15.75em!important;
	 overflow: hidden;
	 border-radius: 0.5em;
	 text-decoration: none;
	 background: white;
	 padding: 2.75em 1.5em;
	 box-shadow: 0 1.5em 2.5em -0.5em rgba(0, 0, 0, .3);
	 transition: transform 0.45s ease, background 0.45s ease;
}
 .pack h3 {
	 color: #2e3c40;
	 font-size: 3.5em;
	 font-weight: 600;
	 line-height: 1;
	 padding-bottom: 0.5em;
	 margin: 0 0 0.142857143em;
	 border-bottom: 2px solid #ffa409;
	 transition: color 0.45s ease, border 0.45s ease;
}

 .pack h4 {
	 color: #627084;
	 text-transform: uppercase;
	 font-size: 1.125em;
	 font-weight: 700;
	 line-height: 1;
	 letter-spacing: 0.1em;
	 margin: 0 0 1.777777778em;
	 transition: color 0.45s ease;
}
 .pack p {
	 opacity: 0;
	 color: #fff;
	 font-weight: 600;
	 line-height: 1.8;
	 margin: 0 0 1.25em;
	 transform: translateY(-1em);
	 transition: opacity 0.45s ease, transform 0.5s ease;
}
 .pack .link-text {
	 display: block;
	 color: #ffa409;
	 font-size: 1.125em;
	 font-weight: 600;
	 line-height: 1.2;
	 margin: auto 0 0;
	 transition: color 0.45s ease;
}
 .pack .link-text svg {
	 margin-left: 0.5em;
	 transition: transform 0.6s ease;
}
 .pack .link-text svg path {
	 transition: fill 0.45s ease;
}
 .pack:hover {
	 background: #ffa409!important;
	 transform: scale(1.02)!important;
}
.pack:focus {
	 background: #ffa409!important;
	 transform: scale(1.02)!important;
}
 .pack:hover h3 {
	 color: #fff!important;
	 border-bottom-color: #ffa409!important;
}
.pack:focus h3 {
	 color: #fff!important;
	 border-bottom-color: #ffa409!important;
}
 .pack:hover h4 {
	 color: #fff!important;
}
.pack:focus h4 {
	 color: #fff!important;
}
 .pack:hover p {
	 opacity: 1!important;
	 transform: none!important;
}
.pack:focus p {
	 opacity: 1!important;
	 transform: none!important;
}
 .pack:hover .link-text {
	 color: #fff!important;
}
.pack:focus .link-text {
	 color: #fff!important;
}
 .pack:hover .link-text svg {
	 animation: point 1.25s infinite alternate!important;
}
.pack:focus .link-text svg {
	 animation: point 1.25s infinite alternate!important;
}
 .pack:hover .link-text svg path {
	 fill: #fff!important;
}
.pack:focus .link-text svg path {
	 fill: #fff!important;
}
 @keyframes point {
	 0% {
		 transform: translateX(0);
	}
	 100% {
		 transform: translateX(0.125em);
	}
}






.pack-mobile {
	 display: block;
	 flex-direction: column;
	 overflow: hidden;
	 border-radius: 0.5em;
	 text-decoration: none;
	 background: white;
	 box-shadow: 0 1.5em 2.5em -0.5em rgba(0, 0, 0, .3);
	 transition: transform 0.45s ease, background 0.45s ease;
}
 .pack-mobile h3 {
	 color: #2e3c40;
	 font-size: 3.5em;
	 font-weight: 600;
	 line-height: 1;
	 //padding-bottom: 0.5em;
	 margin: 0 0 0.142857143em;
	 border-bottom: 2px solid #ffa409;
	 transition: color 0.45s ease, border 0.45s ease;
}

 .pack-mobile h4 {
	 color: #627084;
	 text-transform: uppercase;
	 font-size: 1.125em;
	 font-weight: 700;
	 line-height: 1;
	 letter-spacing: 0.1em;
	 margin: 0 0 1.777777778em;
	 transition: color 0.45s ease;
}
 .pack-mobile p {
	 opacity: 0;
	 color: #fff;
	 font-weight: 600;
	 line-height: 1.8;
	 margin: 0 0 1.25em;
	 transform: translateY(-1em);
	 transition: opacity 0.45s ease, transform 0.5s ease;
}
 .pack-mobile .link-text {
   margin-top:-20px!important;
	 display: block;
	 color: #ffa409;
	 font-size: 1.125em;
	 font-weight: 600;
	 line-height: 1.2;
	 margin: auto 0 0;
	 transition: color 0.45s ease;
}
 .pack-mobile .link-text svg {
	 margin-left: 0.5em;
	 transition: transform 0.6s ease;
}
 .pack-mobile .link-text svg path {
	 transition: fill 0.45s ease;
}
 .pack-mobile:hover {
	 background: #ffa409!important;
	 transform: scale(1.02)!important;
}
.pack-mobile:focus {
	 background: #ffa409!important;
	 transform: scale(1.02)!important;
}
 .pack-mobile:hover h3 {
	 color: #fff!important;
	 border-bottom-color: #ffa409!important;
}
.pack-mobile:focus h3 {
	 color: #fff!important;
	 border-bottom-color: #ffa409!important;
}
 .pack-mobile:hover h4 {
	 color: #fff!important;
}
.pack-mobile:focus h4 {
	 color: #fff!important;
}
 .pack-mobile:hover p {
	 opacity: 1!important;
	 transform: none!important;
}
.pack-mobile:focus p {
	 opacity: 1!important;
	 transform: none!important;
}
 .pack-mobile:hover .link-text {
	 color: #fff!important;
}
.pack-mobile:focus .link-text {
	 color: #fff!important;
}
 .pack-mobile:hover .link-text svg {
	 animation: point 1.25s infinite alternate!important;
}
.pack-mobile:focus .link-text svg {
	 animation: point 1.25s infinite alternate!important;
}
 .pack-mobile:hover .link-text svg path {
	 fill: #fff!important;
}
.pack-mobile:focus .link-text svg path {
	 fill: #fff!important;
}
 @keyframes point {
	 0% {
		 transform: translateX(0);
	}
	 100% {
		 transform: translateX(0.125em);
	}
}


// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}







/* Styles pour les cartes d'assureurs - repris du composant auto.desktop.vue */
.insurers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .insurers-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.insurer-card {
  position: relative;
  border-radius: 12px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.insurer-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #cbd5e0;
}

.insurer-card.selected {
  border-color: #ffa409;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 100%);
}

.insurer-card.all-insurers {
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  border-color: #ffa409;
  color: white;
}

.insurer-card.all-insurers.selected {
  background: linear-gradient(135deg, #e69500 0%, #cc7a00 100%);
  transform: scale(1.02);
}

.insurer-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.insurer-label {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
}

.insurer-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border-radius: 12px;
  margin-right: 1rem;
  transition: all 0.3s ease;
}

.insurer-card.selected .insurer-icon {
  background: rgba(255, 164, 9, 0.1);
}

.insurer-card.all-insurers .insurer-icon {
  background: rgba(255, 255, 255, 0.2);
}

.insurer-logo {
  max-width: 45px;
  max-height: 45px;
  object-fit: contain;
  filter: brightness(1);
  transition: all 0.3s ease;
}

.insurer-card.all-insurers .insurer-logo {
  filter: brightness(0) invert(1);
}

.insurer-info {
  flex: 1;
  min-width: 0;
}

.insurer-name {
  font-weight: 500;
  color: #2d3748;
  margin: 0 0 0.25rem 0;
  line-height: 1.2;
  word-break: break-word;
}

.insurer-card.all-insurers .insurer-name {
  color: white;
}

.insurer-badge {
  display: inline-block;
  font-size: 0.90rem;
  font-weight: 500;
  color: #718096;
  background: #edf2f7;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.insurer-card.all-insurers .insurer-badge {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.insurer-card.selected .insurer-badge {
  background: rgba(255, 164, 9, 0.2);
  color: #b45309;
}

.selection-indicator {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0.8);
}

.insurer-card.selected .selection-indicator {
  opacity: 1;
  transform: scale(1);
  background: #ffa409;
  color: white;
}

.selection-indicator i {
  font-size: 0.75rem;
}

.selection-summary {
  background: linear-gradient(135deg, #e6fffa 0%, #f0fff4 100%);
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.summary-content {
  display: flex;
  align-items: center;
  color: #2f855a;
  font-weight: 500;
}

.summary-content i {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

/* Animation d'entrée */
.insurer-card {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animation pour les cartes sélectionnées */
.insurer-card.selected {
  animation: pulse 0.6s ease-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}

/* Responsive amélioré */
@media (max-width: 480px) {
  .insurer-label {
    padding: 1rem;
  }
  
  .insurer-icon {
    width: 50px;
    height: 50px;
    margin-right: 0.75rem;
  }
  
  .insurer-logo {
    max-width: 35px;
    max-height: 35px;
  }
  
  .insurer-name {
    font-size: 1.5rem;
  }
}

/* Amélioration de l'accessibilité */
.insurer-card:focus-within {
  outline-offset: 2px;
}

.insurer-input:focus + .insurer-label {
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.3);
}

/* États de chargement */
.insurers-grid.loading .insurer-card {
  opacity: 0.6;
  pointer-events: none;
}
</style>






